/**
 * AUTO-GENERATED — do not edit by hand.
 *
 * Generated from scripts/visible-audit/audit-specs-visible.json by
 * scripts/generate-visible-specs-index.mjs.
 *
 * To update: edit audit-specs-visible.json, then run:
 *   node scripts/generate-visible-specs-index.mjs
 *
 * Stats:
 *   - 2501 flagship visible-light cameras with verified-or-better specs
 *   - 122 fully verified from manufacturer datasheets
 *   - 2347 with ratings only (IP/IK/ONVIF read from a labelled field)
 *   - 30 inferred from sibling models
 *   - 2 unknown (need datasheet)
 *   - 37 NDAA Section 889 compliant
 *
 * Models NOT in this index fall back to generic defaults
 * (TYPICAL_BITRATES + TYPICAL_POE_POWER) — those work but lack engineering precision.
 */

import type { VisibleIndexEntry } from '@/lib/visible/types';

export const VISIBLE_SPECS_INDEX: Readonly<Record<string, VisibleIndexEntry>> = {
  "AXIS M3068-P": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-m3068-p"
    ],
    "type": "fisheye",
    "spec": {
      "resolution": "2880x2880",
      "megapixels": 12,
      "sensorSize": "1/1.7\"",
      "focalLength": "1.65 mm",
      "hfov_deg": 185,
      "minIllumination_lux": 0.32,
      "minIlluminationColorLux": 0.32,
      "minIlluminationBwLux": 0.06,
      "minIlluminationColorConditions": "50 IRE, F2.8",
      "minIlluminationBwConditions": "50 IRE, F2.8",
      "minIlluminationApertureF": 2.8,
      "powerConsumption_w": 6.49,
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "operatingTemp_min_c": 0,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 1.9,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Indoor 12MP 360 fisheye mini-dome with 1/1.7\" sensor",
      "No built-in IR; no IP/IK rating (indoor)",
      "Forensic WDR + Zipstream; 30 fps at full resolution",
      "Power consumption ~6.5W via PoE"
    ]
  },
  "AXIS M3215-LVE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-m3215-lve",
      "https://www.axis.com/dam/public/cb/ef/2a/datasheet-axis-m3215-lve-dome-camera-en-US-405335.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "3.1 mm (fixed)",
      "hfov_deg": 101,
      "irRange_m": 30,
      "minIllumination_lux": 0.14,
      "minIlluminationColorLux": 0.14,
      "minIlluminationColorConditions": "50 IRE, F2.0",
      "minIlluminationApertureF": 2,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "white",
      "powerConsumption_w": 10.4,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.96,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Outdoor entry-level vandal dome with deep learning",
      "OptimizedIR up to 30m (or more depending on scene)",
      "Typical 4.8W, max 10.4W via PoE 802.3af Class 3",
      "Forensic WDR"
    ]
  },
  "AXIS M3216-LVE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-m3216-lve",
      "https://www.axis.com/dam/public/a0/ed/76/datasheet-axis-m3216-lve-dome-camera-en-US-418022.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1512",
      "megapixels": 4,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.9 mm (fixed)",
      "hfov_deg": 102,
      "irRange_m": 30,
      "minIllumination_lux": 0.16,
      "minIlluminationColorLux": 0.16,
      "minIlluminationColorConditions": "50 IRE, F2.0",
      "minIlluminationApertureF": 2,
      "monoIsIrAssistedZero": true,
      "powerConsumption_w": 10.8,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.32,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Outdoor entry-level vandal dome 4MP with deep learning",
      "OptimizedIR up to 30m",
      "Typical 4.8W, max 10.8W via PoE 802.3af/at Class 3",
      "Forensic WDR"
    ]
  },
  "AXIS P1455-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p1455-le",
      "https://www.axis.com/dam/public/d8/b3/fd/datasheet-axis-p1455-le-network-camera-en-US-352221.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "3-9 mm or 10.9-29 mm (two lens variants)",
      "hfovRange_raw": "114-37 (wide) / 29-11 (tele)",
      "irRange_m": 40,
      "minIllumination_lux": 0.07,
      "minIlluminationColorLux": 0.07,
      "minIlluminationBwLux": 0.01,
      "minIlluminationColorConditions": "50 IRE F1.6",
      "minIlluminationBwConditions": "50 IRE F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR (40m)",
      "Operating temp -40 to 60 C",
      "Power consumption max not extracted (datasheet behind PDF render); typical Axis P14xx-LE is ~13W max via PoE+"
    ]
  },
  "AXIS P1465-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p1465-le",
      "https://www.axis.com/dam/public/6c/06/76/datasheet-axis-p1465-le-bullet-camera-en-US-480987.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "3-9 mm or 10.9-29 mm (two lens variants)",
      "hfovRange_raw": "117-37 (wide) / 29-11 (tele)",
      "irRange_m": 40,
      "minIllumination_lux": 0.06,
      "minIlluminationColorLux": 0.06,
      "minIlluminationBwLux": 0.01,
      "minIlluminationColorConditions": "50 IRE F1.6",
      "minIlluminationBwConditions": "50 IRE F1.6",
      "minIlluminationApertureF": 1.6,
      "powerConsumption_w": 12.95,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR",
      "Typical power 7.9W, max 12.95W via PoE 802.3at Class 3",
      "OptimizedIR adapts to scene; range up to 40m"
    ]
  },
  "AXIS P1467-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p1467-le"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2592x1944",
      "megapixels": 5,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8-8 mm",
      "hfovRange_raw": "106-38",
      "irRange_m": 40,
      "minIllumination_lux": 0.13,
      "minIlluminationColorLux": 0.13,
      "minIlluminationBwLux": 0.03,
      "minIlluminationColorConditions": "50 IRE F1.3",
      "minIlluminationBwConditions": "50 IRE F1.3",
      "minIlluminationApertureF": 1.3,
      "powerConsumption_w": 12.95,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR (40m, 850nm LEDs)",
      "Typical 5.8W, max 12.95W via PoE 802.3at Class 3",
      "Max 180 fps capture"
    ]
  },
  "AXIS P1468-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p1468-le"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.2\"",
      "focalLength": "6.2-12.9 mm",
      "hfovRange_raw": "108-49",
      "irRange_m": 40,
      "minIllumination_lux": 0.07,
      "minIlluminationColorLux": 0.07,
      "minIlluminationBwLux": 0.01,
      "minIlluminationColorConditions": "50 IRE F1.6",
      "minIlluminationBwConditions": "50 IRE F1.6",
      "minIlluminationApertureF": 1.6,
      "powerConsumption_w": 12.95,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.22,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "4K with large 1/1.2\" sensor — flagship low-light bullet",
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR (40m)",
      "Typical 7.7W, max 12.95W via PoE 802.3at Class 3"
    ]
  },
  "AXIS P3245-LVE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p3245-lve",
      "https://www.axis.com/dam/public/c8/96/79/datasheet-axis-p3245-lve-network-camera-en-US-388187.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "3.4-8.9 mm or 9-22 mm",
      "hfovRange_raw": "100-36 (wide) / 35-15 (tele)",
      "irRange_m": 40,
      "minIllumination_lux": 0.1,
      "minIlluminationColorLux": 0.1,
      "minIlluminationBwLux": 0.02,
      "minIlluminationColorConditions": "50 IRE, F1.8",
      "minIlluminationBwConditions": "50 IRE, F1.8",
      "minIlluminationApertureF": 1.8,
      "powerConsumption_w": 10.7,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Outdoor 2MP fixed dome",
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR",
      "PoE 802.3af/at, max ~10.7W"
    ]
  },
  "AXIS P3265-LV": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p3265-lv",
      "https://www.axis.com/dam/public/76/bc/cf/datasheet-axis-p3265-lv-dome-camera-en-US-359780.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "3.4-8.9 mm",
      "hfovRange_raw": "100-36",
      "irRange_m": 40,
      "minIllumination_lux": 0.1,
      "minIlluminationColorLux": 0.1,
      "minIlluminationColorConditions": "50 IRE, F1.8",
      "minIlluminationApertureF": 1.8,
      "monoIsIrAssistedZero": true,
      "powerConsumption_w": 8.9,
      "ipRating": "IP52",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "II",
      "operatingTemp_min_c": 0,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Indoor 2MP dome with deep learning DLPU",
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR (~40m)",
      "Max power 8.9W via PoE Class 3"
    ]
  },
  "AXIS P3267-LV": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p3267-lv",
      "https://www.axis.com/dam/public/63/b1/c9/datasheet-axis-p3267-lv-dome-camera-en-US-367608.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2592x1944",
      "megapixels": 5,
      "sensorSize": "1/2.7\"",
      "focalLength": "3-8 mm",
      "hfovRange_raw": "104-40",
      "irRange_m": 40,
      "minIllumination_lux": 0.13,
      "minIlluminationColorLux": 0.13,
      "minIlluminationColorConditions": "50 IRE, F1.3",
      "minIlluminationApertureF": 1.3,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "white",
      "powerConsumption_w": 9,
      "ipRating": "IP52",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "II",
      "operatingTemp_min_c": 0,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Indoor 5MP dome with deep learning",
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR (40m, 850nm)",
      "Typical 6.4W, max 9.0W"
    ]
  },
  "AXIS P3268-LV": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p3268-lv",
      "https://www.axis.com/dam/public/82/2a/91/datasheet-axis-p3268-lv-dome-camera-en-US-367678.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "4.3-8.6 mm",
      "hfovRange_raw": "100-53",
      "irRange_m": 40,
      "minIllumination_lux": 0.14,
      "minIlluminationColorLux": 0.14,
      "minIlluminationColorConditions": "50 IRE, F1.5",
      "minIlluminationApertureF": 1.5,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "white",
      "powerConsumption_w": 10,
      "ipRating": "IP52",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "II",
      "operatingTemp_min_c": 0,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Indoor 4K (8MP) dome with deep learning, 1/1.8\" sensor",
      "Lightfinder 2.0 + Forensic WDR + OptimizedIR (40m) + EIS",
      "Typical 5.5W, max 10W via PoE Class 3"
    ]
  },
  "AXIS P3727-PLE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p3727-ple",
      "https://www.axis.com/dam/public/86/39/b5/datasheet-axis-p3727-ple-panoramic-camera-en-US-367659.pdf"
    ],
    "type": "multisensor",
    "spec": {
      "resolution": "4 x 1920x1080",
      "megapixels": 8,
      "sensorSize": "1/2.8\"",
      "focalLength": "3-6 mm",
      "hfov_deg": 360,
      "irRange_m": 15,
      "minIllumination_lux": 0.17,
      "minIlluminationColorLux": 0.17,
      "minIlluminationColorConditions": "50 IRE, F1.8",
      "minIlluminationApertureF": 1.8,
      "monoIsIrAssistedZero": true,
      "powerConsumption_w": 21.7,
      "ipRating": "IP66/IP67",
      "ikRating": "IK09",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 1.58,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "4x 2MP multidirectional outdoor panoramic — 360 coverage",
      "Built-in IR with 360 illumination, range ~15m",
      "Max 21.7W via PoE Class 4 (12.95-25.5W)",
      "Lightfinder + Forensic WDR + Zipstream"
    ]
  },
  "AXIS P3807-PVE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p3807-pve"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "4320x1920",
      "megapixels": 8.3,
      "sensorSize": "1/2.9\" (4 sensors stitched)",
      "focalLength": "3.2 mm",
      "hfov_deg": 180,
      "minIllumination_lux": 0.17,
      "minIlluminationColorLux": 0.17,
      "minIlluminationBwLux": 0.05,
      "minIlluminationColorConditions": "F2.0",
      "minIlluminationBwConditions": "F2.0",
      "minIlluminationApertureF": 2,
      "powerConsumption_w": 12.9,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 4,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Outdoor 180-degree multi-sensor panoramic, 8MP stitched",
      "No built-in IR",
      "Lightfinder + Forensic WDR + Zipstream",
      "Typical 7W, max 12.9W via PoE",
      "Note: cameras.ts has 'AXIS P3807' — assumed P3807-PVE (only PVE variant exists in this series)"
    ]
  },
  "AXIS P5655-E": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-p5655-e",
      "https://www.axis.com/dam/public/30/86/05/datasheet-axis-p5655%E2%80%93e-ptz-network-camera-en-US-338957.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.3-137.6 mm (32x optical)",
      "hfovRange_raw": "58.3-2.4",
      "minIllumination_lux": 0.1,
      "minIlluminationColorLux": 0.1,
      "minIlluminationBwLux": 0.01,
      "minIlluminationColorConditions": "30 IRE F1.4",
      "minIlluminationBwConditions": "30 IRE F1.4",
      "minIlluminationApertureF": 1.4,
      "powerConsumption_w": 19,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 120
    },
    "notes": [
      "Cost-effective outdoor PTZ, 32x zoom, no built-in IR",
      "Lightfinder 2.0 (B/W 0.01 lux); EIS",
      "Typical 10.5W, max 19W via PoE+ 802.3at",
      "360 endless pan, 180 tilt"
    ]
  },
  "AXIS Q1656": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-q1656",
      "https://www.axis.com/dam/public/2f/ad/1a/datasheet-axis-q1656-box-camera-en-US-506838.pdf"
    ],
    "type": "box",
    "spec": {
      "resolution": "2688x1512",
      "megapixels": 4,
      "sensorSize": "1/1.8\"",
      "focalLength": "3.9-10 mm",
      "hfovRange_raw": "120-47",
      "minIllumination_lux": 0.05,
      "minIlluminationColorLux": 0.05,
      "minIlluminationBwLux": 0.01,
      "minIlluminationColorConditions": "50 IRE, F1.5",
      "minIlluminationBwConditions": "50 IRE, F1.5",
      "minIlluminationApertureF": 1.5,
      "powerConsumption_w": 8.2,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "II",
      "operatingTemp_min_c": 0,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Indoor box camera (no built-in IR) — Q1656-LE is the LE/heater variant",
      "Lightfinder 2.0; 0.05 lux color, 0.01 lux B/W",
      "Typical 4.6W, max 7.7W via PoE; up to 8.2W on DC"
    ]
  },
  "AXIS Q1715": {
    "manufacturer": "Axis",
    "status": "inferred",
    "sources": [
      "https://www.axis.com/products/axis-q1715",
      "https://www.axis.com/dam/public/d7/a6/74/datasheet-axis-q1715-block-camera-en-US-359763.pdf"
    ],
    "type": "box",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "4-84.6 mm",
      "hfovRange_raw": "76-3.6",
      "minIllumination_lux": 0.1,
      "minIlluminationColorLux": 0.1,
      "minIlluminationBwLux": 0.02,
      "minIlluminationColorConditions": "50 IRE F1.5",
      "minIlluminationBwConditions": "50 IRE F1.5",
      "minIlluminationApertureF": 1.5,
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "operatingTemp_min_c": 0,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Block/box camera with 21x optical zoom (4-84.6mm)",
      "Lightfinder 2.0; B/W 0.02 lux",
      "Indoor block camera — no IP rating expected (housed when outdoor)",
      "Power: PoE 802.3af Type1 Class 3 or 802.3at Type2 Class 4 / 10-28V DC; max watts not extracted"
    ]
  },
  "AXIS Q1798-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-q1798-le/support",
      "https://www.axis.com/dam/public/19/77/a5/datasheet-axis-q1798-le-network-camera-en-US-336738.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3712x2784",
      "megapixels": 10,
      "sensorSize": "4/3\"",
      "focalLength": "12-48 mm",
      "hfovRange_raw": "90-21",
      "minIllumination_lux": 0.03,
      "minIlluminationColorLux": 0.03,
      "minIlluminationBwLux": 0.006,
      "minIlluminationColorConditions": "50 IRE F1.7",
      "minIlluminationBwConditions": "50 IRE F1.7",
      "minIlluminationApertureF": 1.7,
      "powerConsumption_w": 24,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 4.73,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Flagship 10MP with massive 4/3\" sensor and Canon lens — ultra low-light",
      "Lightfinder 2.0; 0.03 lux color (one of the lowest in Axis lineup)",
      "PoE typical 13.3W, max 24.0W; AC up to 33W",
      "cameras.ts uses 'AXIS Q1798' (no -LE) — this entry covers that SKU; Q1798-LE replaced by Q1808-LE per Axis"
    ]
  },
  "AXIS Q6125-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-q6125-le",
      "https://www.axis.com/dam/public/3a/3e/34/datasheet-axis-q6125-le-ptz-network-camera-en-US-300922.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.3-129 mm (30x optical)",
      "hfovRange_raw": "63.5-2.3",
      "irRange_m": 200,
      "minIllumination_lux": 0.1,
      "minIlluminationColorLux": 0.1,
      "minIlluminationBwLux": 0.008,
      "minIlluminationColorConditions": "30 IRE, F1.6",
      "minIlluminationBwConditions": "30 IRE, F1.6",
      "minIlluminationApertureF": 1.6,
      "powerConsumption_w": 25,
      "ipRating": "IP66",
      "ikRating": "IK08",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 120
    },
    "notes": [
      "Outdoor PTZ with long-range OptimizedIR",
      "IR range 150m (30W midspan) or 200m+ (60W midspan)",
      "Typical 14W, max 25W via High PoE",
      "Lightfinder + Forensic WDR + EIS; B/W 0.01 lux",
      "Minimum illumination corrected from 0.15 lx to 0.1 lx from the manufacturer datasheet (30 IRE, F1.6); the previous figure carried no measurement conditions."
    ]
  },
  "AXIS Q6135-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-q6135-le",
      "https://www.axis.com/dam/public/e2/bf/8b/datasheet-axis-q6135-le-ptz-network-camera-en-US-506812.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.3-137.6 mm (32x optical)",
      "hfovRange_raw": "58.3-2.4",
      "irRange_m": 250,
      "minIllumination_lux": 0.06,
      "minIlluminationColorLux": 0.06,
      "minIlluminationBwLux": 0.008,
      "minIlluminationColorConditions": "30 IRE F1.4",
      "minIlluminationBwConditions": "30 IRE F1.4",
      "minIlluminationApertureF": 1.4,
      "powerConsumption_w": 25,
      "ipRating": "IP66",
      "ikRating": "IK08",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 120
    },
    "notes": [
      "High-speed outdoor PTZ with long-range OptimizedIR up to 250m",
      "Lightfinder 2.0 (B/W 0.008 lux — exceptional)",
      "Typical 13.5W, max 25W; comes with 60W midspan",
      "Autotracking 2 + Forensic WDR + EIS"
    ]
  },
  "AXIS Q6315-LE": {
    "manufacturer": "Axis",
    "status": "verified",
    "sources": [
      "https://www.axis.com/products/axis-q6315-le",
      "https://www.axis.com/dam/public/35/41/87/datasheet-axis-q6315-le-ptz-network-camera-en-US-352224.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2.1,
      "sensorSize": "1/2\"",
      "focalLength": "6.91-214.64 mm (31x optical)",
      "hfovRange_raw": "60.6-2.0",
      "irRange_m": 300,
      "minIllumination_lux": 0.06,
      "minIlluminationColorLux": 0.06,
      "minIlluminationBwLux": 0.001,
      "minIlluminationColorConditions": "30 IRE, F1.36",
      "minIlluminationBwConditions": "30 IRE, F1.36",
      "minIlluminationApertureF": 1.36,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264",
        "H.265"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.82,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 120
    },
    "notes": [
      "Flagship high-end PTZ with long-range OptimizedIR up to 300m",
      "Lightfinder 2.0 (B/W 0.001 lux — best in class)",
      "Quick-zoom + laser focus; large 1/2\" sensor",
      "Comes with 60W midspan; max watts not extracted but typical ~25-30W class"
    ]
  },
  "DS-2CD2023G2": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/S000000025/OFR007888/M000037840/Data_Sheet/DS-2CD2023G2-IU-D_Datasheet_20240724.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 107,
      "irRange_m": 40,
      "vfov_deg": 57,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Base SKU = DS-2CD2023G2-I; -IU adds built-in mic. 2.8mm variant.",
      "Datasheet also lists 4mm (HFOV 87) and 6mm (HFOV 54) lens options."
    ]
  },
  "DS-2CD2023G2-IU": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/S000000025/OFR007888/M000037840/Data_Sheet/DS-2CD2023G2-IU-D_Datasheet_20240724.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 107,
      "irRange_m": 40,
      "vfov_deg": 57,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "-U variant adds built-in microphone. Same lens, sensor and ratings as base.",
      "2.8mm variant; datasheet also offers 4mm and 6mm SKUs."
    ]
  },
  "DS-2CD2043G2": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/acusense-series/Datasheet-for-DS-2CD2043G2-IU.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 103,
      "irRange_m": 40,
      "vfov_deg": 55,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "AcuSense bullet, 4MP. 2.8mm SKU listed; datasheet also lists 4mm (HFOV 84) and 6mm (HFOV 52)."
    ]
  },
  "DS-2CD2043G2-IU": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/acusense-series/Datasheet-for-DS-2CD2043G2-IU.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 103,
      "irRange_m": 40,
      "vfov_deg": 55,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "-IU variant: built-in mic. Same optics/ratings as base 2043G2."
    ]
  },
  "DS-2CD2143G2": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/DS-2CD2143G2-IU-DataSheet.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 103,
      "irRange_m": 30,
      "vfov_deg": 55,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 6.5,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Vandal-resistant dome (often called turret in NA). 2.8mm SKU; datasheet also lists 4mm (HFOV 84)."
    ]
  },
  "DS-2CD2147G2": {
    "manufacturer": "Hikvision",
    "status": "inferred",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/colorvu-ip/Datasheet-for-DS-2CD2147G2-LSU.pdf",
      "https://www.hikvision.com/en/products/IP-Products/Network-Cameras/Pro-Series-EasyIP-/ds-2cd2147g2--su-/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "vfov_deg": 61,
      "minIllumination_lux": 0.0005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 6.5,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "DS-2CD2147G2(-SU) is the ColorVu (white-light) sibling of -LSU (no audio); F1.0 lens, 30m white-light range, 24/7 color. Inferred from -LSU datasheet — same optics + sensor.",
      "White light range 30m (no IR). Inferred from -LSU datasheet."
    ]
  },
  "DS-2CD2147G2-LSU": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/colorvu-ip/Datasheet-for-DS-2CD2147G2-LSU.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "vfov_deg": 61,
      "minIllumination_lux": 0.0005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 6.5,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "ColorVu Fixed Dome with F1.0 super-aperture, 24/7 color. White-light supplement up to 30m (no IR).",
      "-LSU = built-in microphone, audio + alarm I/O. 2.8mm SKU; 4mm option HFOV 95."
    ]
  },
  "DS-2CD2147G2H": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://assets.hikvision.com/prd/public/all/doc/sm000051126/DS-2CD2147G2H-LISU_Datasheet_20240116.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 104,
      "irRange_m": 30,
      "vfov_deg": 54.4,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "monoIsIrAssistedZero": true,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 6.5,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "G2H = Smart Hybrid Light (IR + White Light, switches at event). 'Up to 30m' applies to both IR and white-light supplement.",
      "2.8mm SKU; 4mm option HFOV 89.2. 130dB WDR."
    ]
  },
  "DS-2CD2386G2": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://assets.hikvision.com/prd/public/all/doc/sm000059270/DS-2CD2386G2-IU-C_Datasheet_V5.5.112_20230217.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 111,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.003,
      "minIlluminationColorLux": 0.003,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 6.8,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "8MP 4K AcuSense Powered-by-DarkFighter Turret. 2.8mm SKU. Datasheet also offers 4mm (HFOV 87) and 6mm (HFOV 51).",
      "Turret form factor; type=dome in CCTVplanner schema."
    ]
  },
  "DS-2CD2386G2H": {
    "manufacturer": "Hikvision",
    "status": "inferred",
    "sources": [
      "https://assets.hikvision.com/prd/public/all/doc/sm000059270/DS-2CD2386G2-IU-C_Datasheet_V5.5.112_20230217.pdf",
      "https://assets.hikvision.com/prd/public/all/doc/sm000051126/DS-2CD2147G2H-LISU_Datasheet_20240116.pdf"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 102,
      "irRange_m": 30,
      "vfov_deg": 52,
      "minIllumination_lux": 0.003,
      "minIlluminationColorLux": 0.003,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 11,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "G2H = Smart Hybrid Light variant of 2386G2 (8MP ColorVu + IR). Inferred from sibling 2147G2H datasheet structure and 8MP sensor mate. Confirm vs DS-2CD2387G2H-LIU datasheet before pricing.",
      "INFERRED — please verify exact SKU from a vetted distributor before quoting customer.",
      "Minimum illumination corrected from 0.0005 lx to 0.003 lx from the manufacturer datasheet (conditions not stated); the previous figure carried no measurement conditions."
    ]
  },
  "DS-2CD2386G2P": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/colorvu-ip/Datasheet-for-DS-2CD2387G2P-LSU_SL.pdf"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "5120x1440",
      "megapixels": 8,
      "sensorSize": "2x1/1.8\"",
      "focalLength": "4mm (dual)",
      "hfov_deg": 180,
      "vfov_deg": 44,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "monoIsIrAssistedZero": true,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 12.5,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Inventory model 'DS-2CD2386G2P' likely refers to DS-2CD2387G2P-LSU/SL — dual-sensor 180-deg panoramic ColorVu turret. Confirm exact SKU; 2386G2P is not a current Hikvision part number.",
      "Stitched 5120x1440 image at 20fps (12.5fps with WDR). White-light supplement up to 30m. PoE+ Class 3."
    ]
  },
  "DS-2CD2T47G2": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/S000000025/OFR007893/M000032057/Data_Sheet/DS-2CD2T47G2-L-C_Datasheet_V5.5.112_20230418.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "vfov_deg": 61,
      "minIllumination_lux": 0.0005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 10.5,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Inventory entry 'DS-2CD2T47G2' is incomplete; closest current SKU is DS-2CD2T47G2-L (ColorVu) — used as reference. White-light range 60m (no IR).",
      "2.8mm SKU; 4mm = HFOV 95, 6mm = HFOV 58."
    ]
  },
  "DS-2CD2T47G2-L": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/S000000025/OFR007893/M000032057/Data_Sheet/DS-2CD2T47G2-L-C_Datasheet_V5.5.112_20230418.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "vfov_deg": 61,
      "minIllumination_lux": 0.0005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 10.5,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "4MP ColorVu Fixed Bullet, F1.0 aperture, white-light supplement up to 60m, no IR.",
      "2.8mm SKU; 4mm = HFOV 95, 6mm = HFOV 58. 130dB WDR."
    ]
  },
  "DS-2CD2T47G2-LSU/SL": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://assets.hikvision.com/prd/public/all/doc/sm000058375/DS-2CD2T47G2-LSU_SL-C_Datasheet_V5.5.114_20230418.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 111.9,
      "vfov_deg": 60.5,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "monoIsIrAssistedZero": true,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 9,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.09,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Strobe-light + audible-warning ColorVu bullet; built-in mic + speaker. White-light supplement up to 60m.",
      "2.8mm SKU; 4mm = HFOV 95.2, 6mm = HFOV 58.4. PoE max 9W."
    ]
  },
  "DS-2CD2T87G2": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://assets.hikvision.com/prd/public/all/doc/sm000064613/DS-2CD2T87G2-L-C_Datasheet_V5.5.115_20230418.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.2\"",
      "focalLength": "2.8mm",
      "hfov_deg": 102,
      "vfov_deg": 52,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "monoIsIrAssistedZero": true,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 9.5,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.28,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Inventory entry 'DS-2CD2T87G2' is incomplete; resolved to DS-2CD2T87G2-L (8MP ColorVu Bullet). 1/1.2-inch sensor, F1.0, 60m white-light, 24fps at 4K (60Hz).",
      "2.8mm SKU; 4mm = HFOV 88, 6mm = HFOV 54."
    ]
  },
  "DS-2CD2T87G2-L": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://assets.hikvision.com/prd/public/all/doc/sm000064613/DS-2CD2T87G2-L-C_Datasheet_V5.5.115_20230418.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.2\"",
      "focalLength": "2.8mm",
      "hfov_deg": 102,
      "vfov_deg": 52,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "monoIsIrAssistedZero": true,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 9.5,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.28,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "8MP 4K ColorVu Fixed Bullet. 1/1.2\" sensor, F1.0 aperture; white-light up to 60m, no IR.",
      "2.8mm SKU; 4mm = HFOV 88, 6mm = HFOV 54. 4K main stream at 24fps (60Hz)/25fps (50Hz)."
    ]
  },
  "DS-2CD2T87G2-LSU/SL": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/colorvu-ip/DS-2CD2T87G2-LSU-SL-Datasheet.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.2\"",
      "focalLength": "2.8mm",
      "hfov_deg": 102,
      "vfov_deg": 52,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "monoIsIrAssistedZero": true,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 11.5,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 3.28,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "8MP ColorVu Strobe + Audible-Warning Bullet. Built-in mic + speaker, white-light 60m.",
      "2.8mm SKU; 4mm = HFOV 88. PoE max 11.5W (12VDC: 11.5W)."
    ]
  },
  "DS-2CD6332FWD": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/S000001255/OFR000046/M000000404/Data_Sheet/Spec-of-DS-2CD6332FWD-IVS_20220114.pdf"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "2048x1536",
      "megapixels": 3,
      "sensorSize": "1/3\"",
      "focalLength": "1.19mm",
      "hfov_deg": 360,
      "irRange_m": 15,
      "vfov_deg": 180,
      "minIllumination_lux": 0.1,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 12.18,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.4,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "3MP fisheye (older gen — H.265 NOT supported). HFOV 360deg ceiling/table mount, 180deg wall mount.",
      "-V suffix adds IK10/IP66; -S suffix adds audio + RS-485. Older platform — discontinued in some regions."
    ]
  },
  "DS-2CD63C5G0": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/S000001255/OFR000046/M000054679/Data_Sheet/DS-2CD63C5G0-ISB_Datasheet_V5.7.190_20211216.pdf"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "4000x3000",
      "megapixels": 12,
      "sensorSize": "1/1.7\"",
      "focalLength": "1.29mm",
      "hfov_deg": 180,
      "irRange_m": 15,
      "vfov_deg": 180,
      "minIllumination_lux": 0.05,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 12.95,
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 1.9,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "12MP fisheye, 1.29mm panomorph lens (Immervision RPL-89VVT). 360° panoramic when ceiling/table mounted; HFOV/VFOV listed = 180/180 (lens optical FOV).",
      "DS-2CD63C5G0-IS(B) is the indoor-only model — no IP/IK rating. Outdoor variant DS-2CD63C5G0-IVS adds IP67/IK10 + heater (~14W). Confirm SKU before quoting."
    ]
  },
  "DS-2CD7A26G0/P": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/S000000006/OFR000005/M000010374/Data_Sheet/DS-2CD7A26G0-P-IZHS_Datasheet_V5.5.60_-20201125.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 103.3,
      "irRange_m": 50,
      "vfov_deg": 54.2,
      "minIllumination_lux": 0.002,
      "minIlluminationColorLux": 0.002,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 14,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 4.37,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "DeepinView 2MP ANPR/LPR varifocal bullet. 2.8-12mm motorized varifocal (HFOV 103.3deg-38.6deg wide-tele). 8-32mm SKU also exists (HFOV 42.5deg-13.4deg, IR 100m, max 14W).",
      "Designed for license-plate recognition; 140dB WDR; 12VDC max 14W, PoE 802.3at."
    ]
  },
  "DS-2DE2A404IW": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000011/S000000022/OFR000024/M000045324/Data_Sheet/Datasheet-of-DS-2DE2A404IW-DE3S6_V5.7.0_20220704.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 96.7,
      "irRange_m": 20,
      "vfov_deg": 51.1,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 9.2,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.24,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 100
    },
    "notes": [
      "Mini PTZ, 4x optical zoom. HFOV 96.7deg (wide) - 31.6deg (tele). PoE 802.3af, 12VDC 9.2W max.",
      "Pan 0deg-355deg, tilt 0deg-90deg. 120dB WDR."
    ]
  },
  "DS-2DE2A404IW-DE3": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000011/S000000022/OFR000024/M000045324/Data_Sheet/Datasheet-of-DS-2DE2A404IW-DE3S6_V5.7.0_20220704.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 96.7,
      "irRange_m": 20,
      "vfov_deg": 51.1,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 9.2,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.24,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 100
    },
    "notes": [
      "Same as DS-2DE2A404IW: -DE3 = full SKU with PoE+IR (S6 = current rev). 4MP mini PTZ.",
      "HFOV 96.7deg wide, 31.6deg tele. PoE 802.3af."
    ]
  },
  "DS-2DE4A425IW": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/usa/data-sheet/value-ip-ptz/DS-2DE4A425IW-DE.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.8-120mm",
      "hfov_deg": 53.3,
      "irRange_m": 50,
      "vfov_deg": 30.6,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.001,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 18,
      "ipRating": "IP66",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.24,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 100
    },
    "notes": [
      "4MP 4-inch PTZ, 25x optical zoom. HFOV 53.3deg (wide) - 2.6deg (tele). 0.001lx B/W; 120dB WDR.",
      "12VDC 18W max, PoE 802.3at. Pan 360deg endless, tilt -5deg-90deg."
    ]
  },
  "DS-2DE7A425IW": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000011/S000000012/OFR000029/M000048586/Data_Sheet/Datasheet-of-DS-2DE7A425IW-AEBT5_V5.7.0_20220714.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.8-120mm",
      "hfov_deg": 50.8,
      "irRange_m": 200,
      "vfov_deg": 29.4,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.001,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 42,
      "ipRating": "IP66",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 65,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.24,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 100
    },
    "notes": [
      "7-inch 4MP PTZ, 25x optical zoom. HFOV 50.8deg (wide) - 2.6deg (tele). Powered-by-DarkFighter. AcuSense, smart tracking.",
      "24VAC max 42W (incl 18W IR + 10W heater); HiPoE. IR up to 200m."
    ]
  },
  "DS-2DE7A425IW-AEB": {
    "manufacturer": "Hikvision",
    "status": "verified",
    "sources": [
      "https://www.hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000011/S000000012/OFR000029/M000048586/Data_Sheet/Datasheet-of-DS-2DE7A425IW-AEBT5_V5.7.0_20220714.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.8-120mm",
      "hfov_deg": 50.8,
      "irRange_m": 200,
      "vfov_deg": 29.4,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.001,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 42,
      "ipRating": "IP66",
      "codecsSupported": [
        "H.265+",
        "H.265",
        "H.264+",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 65,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.24,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 100
    },
    "notes": [
      "AEB = audio + alarm + built-in speaker (audible-warning + white-flash strobe). T5 = 2022 hardware revision.",
      "Same optics as base; AcuSense, smart tracking, face capture (up to 5 simultaneous)."
    ]
  },
  "IPC-EW5842": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://material.dahuasecurity.com/uploads/soft/20220714/IPC-EBW8842-AS_datasheet.pdf",
      "https://www.dahuasecurity.com/products/All-Products/Network-Cameras/WizMind-Panoramic-Series/Fisheye-Series/IPC-EBW8842-AS"
    ],
    "type": "fisheye",
    "spec": {
      "resolution": "3280x2480",
      "megapixels": 8,
      "sensorSize": "1/1.7\"",
      "focalLength": "1.85mm",
      "hfov_deg": 185,
      "irRange_m": 10,
      "minIllumination_lux": 0.01,
      "minIlluminationColorLux": 0.01,
      "minIlluminationBwLux": 0.001,
      "minIlluminationColorConditions": "F2.0, 30 IRE",
      "minIlluminationBwConditions": "F2.0, 30 IRE",
      "minIlluminationApertureF": 2,
      "maxBitrate_mbps": 16.384,
      "powerConsumption_w": 13.9,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.33,
      "maxTotalBandwidth_mbps": 33,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Exact 'IPC-EW5842' SKU not found in Dahua datasheet repository; inferred from IPC-EBW8842-AS (the documented 8MP WizMind fisheye).",
      "Min illumination color 0.01 lux@F2.0; B/W 0.001 lux; 0 lux with IR on.",
      "Heater adds 3W on top of max consumption; max here is camera+IR only."
    ]
  },
  "IPC-HDBW2441R": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HDBW2441R-ZAS_S0_datasheet_20230920.pdf",
      "https://www.dahuasecurity.com/products/All-Products/Network-Cameras/WizSense-Series/2-Series/IR/IPC-HDBW2441R-ZS"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 104,
      "irRange_m": 40,
      "minIllumination_lux": 0.006,
      "minIlluminationColorLux": 0.006,
      "minIlluminationBwLux": 0.0006,
      "minIlluminationColorConditions": "F1.5, 30 IRE",
      "minIlluminationBwConditions": "F1.5, 30 IRE",
      "minIlluminationApertureF": 1.5,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 7.6,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Bare 'IPC-HDBW2441R' SKU is the lens-base; production SKUs add -ZS/-ZAS (varifocal motorized). HFOV listed for 2.7mm wide end; 13.5mm tele = 29 degrees.",
      "Min illumination 0.006 lux@F1.5 color, 0.0006 B/W.",
      "Power max for ZAS variant (IR + WDR + intelligence): 6.4W DC / 7.6W PoE."
    ]
  },
  "IPC-HDBW3241F": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://www.dahuasecurity.com/products/All-Products/Network-Cameras/WizSense-Series/3-Series/4MP/IPC-HDBW3441F-AS-S2"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 102,
      "irRange_m": 30,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8.192,
      "powerConsumption_w": 7.2,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "IPC-HDBW3241F is the 2MP sibling of HDBW3441F-AS-S2 in the WizSense 3-series; specs inferred by family (same chassis/optics/IR, smaller sensor).",
      "Could not locate an official datasheet under exact 'IPC-HDBW3241F' name; values mirror the verified 4MP unit's power/IP/codecs."
    ]
  },
  "IPC-HDBW3441F": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HDBW3441F-AS-S2_S2_datasheet_20230704.pdf",
      "https://www.dahuasecurity.com/products/All-Products/Network-Cameras/WizSense-Series/3-Series/4MP/IPC-HDBW3441F-AS-S2"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.1mm / 2.8mm / 3.6mm / 6mm",
      "hfov_deg": 102,
      "irRange_m": 30,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.4, 30 IRE",
      "minIlluminationBwConditions": "F1.4, 30 IRE",
      "minIlluminationApertureF": 1.4,
      "maxBitrate_mbps": 8.192,
      "powerConsumption_w": 7.2,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Specs from IPC-HDBW3441F-AS-S2 datasheet (the production SKU for this lens base).",
      "Min illumination: 0.005 lux@F1.4 color (2.8/3.6/6mm); 0.01 lux@F2.0 (2.1mm wide). HFOV reported for 2.8mm option (102 deg).",
      "Power consumption max: 5.9W DC / 7.2W PoE (WDR+IR+Intelligence)."
    ]
  },
  "IPC-HDW2241T": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://cctvcamera.com.sg/wp-content/uploads/IPC-HDW2241T-S_datasheet_20220627.pdf"
    ],
    "type": "turret",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 107,
      "irRange_m": 30,
      "minIllumination_lux": 0.002,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 5.1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Specs from IPC-HDW2241T-S documented variant. 'Eyeball/Turret' form factor.",
      "HFOV 107 deg @ 2.8mm; 88 deg @ 3.6mm."
    ]
  },
  "IPC-HDW2241TM": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HDW2441TM-S_S0_datasheet_20240302.pdf"
    ],
    "type": "turret",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 107,
      "irRange_m": 30,
      "minIllumination_lux": 0.006,
      "minIlluminationColorLux": 0.006,
      "minIlluminationBwLux": 0.0006,
      "minIlluminationColorConditions": "F1.6, 30IRE",
      "minIlluminationBwConditions": "F1.6, 30IRE",
      "minIlluminationApertureF": 1.6,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 5.1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "TM variant adds built-in microphone vs HDW2241T. Specs identical otherwise per Dahua family conventions.",
      "Inferred from 4MP sibling (HDW2441TM-S) and 2MP base (HDW2241T-S).",
      "Minimum illumination corrected from 0.002 lx to 0.006 lx from the manufacturer datasheet (F1.6, 30IRE); the previous figure carried no measurement conditions."
    ]
  },
  "IPC-HDW3441T": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HDW3441T-ZS-S2_S2_datasheet_20240120.pdf",
      "https://www.sintrabaltic.eu/files-products/00/14/71/1471/IPC-HDW3441TM-AS_datasheet_20210329.pdf"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm",
      "hfov_deg": 102,
      "irRange_m": 50,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.5, 30 IRE",
      "minIlluminationBwConditions": "F1.5, 30 IRE",
      "minIlluminationApertureF": 1.5,
      "maxBitrate_mbps": 8.192,
      "powerConsumption_w": 7.7,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Bare 'IPC-HDW3441T' likely refers to AS/TM variant in WizSense 3-series.",
      "TM variant published 50m IR. Max power 7.7W per IPC-HDW3441TM-AS datasheet."
    ]
  },
  "IPC-HDW3441TM": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://www.sintrabaltic.eu/files-products/00/14/71/1471/IPC-HDW3441TM-AS_datasheet_20210329.pdf",
      "https://france.dahuatech.com/upload/datasheets/IPC-HDW3441TM-AS.pdf"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 103,
      "irRange_m": 50,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8.192,
      "powerConsumption_w": 7.7,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "WizSense 3-series 'Lite AI' with built-in mic.",
      "Min illumination 0.005 lux@F1.6 color; 0.0005 lux B/W; 0 lux with IR on."
    ]
  },
  "IPC-HFW2241S": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW2241S-S_S0_datasheet_20240302.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 107,
      "irRange_m": 30,
      "minIllumination_lux": 0.002,
      "minIlluminationColorLux": 0.002,
      "minIlluminationBwLux": 0.0002,
      "minIlluminationColorConditions": "F1.6, 30 IRE",
      "minIlluminationBwConditions": "F1.6, 30 IRE",
      "minIlluminationApertureF": 1.6,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 5.1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "WizSense 2-series 2MP fixed-focal bullet. Min illum 0.002 lux@F1.6 color; 0.0002 lux B/W (Starlight class).",
      "Max power 4.2W DC / 5.1W PoE. 1 IR LED, 30m range."
    ]
  },
  "IPC-HFW2441S": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW2441S-S_datasheet_20221114.pdf",
      "https://www.dahuasecurity.com/products/All-Products/Network-Cameras/WizSense-Series/2-Series/4MP/IPC-HFW2441S-S"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 95,
      "irRange_m": 30,
      "minIllumination_lux": 0.006,
      "minIlluminationColorLux": 0.006,
      "minIlluminationBwLux": 0.0006,
      "minIlluminationColorConditions": "F1.6, 30IRE",
      "minIlluminationBwConditions": "F1.6, 30IRE",
      "minIlluminationApertureF": 1.6,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 5.1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Min illum 0.006 lux@F1.6 color; 0.0006 lux B/W. HFOV 95 deg @ 2.8mm; 78 deg @ 3.6mm.",
      "Max power 4.2W DC / 5.1W PoE."
    ]
  },
  "IPC-HFW2441S-S": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW2441S-S_datasheet_20221114.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 95,
      "irRange_m": 30,
      "minIllumination_lux": 0.006,
      "minIlluminationColorLux": 0.006,
      "minIlluminationBwLux": 0.0006,
      "minIlluminationColorConditions": "F1.6, 30IRE",
      "minIlluminationBwConditions": "F1.6, 30IRE",
      "minIlluminationApertureF": 1.6,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 5.1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Identical to 'IPC-HFW2441S' inventory entry — '-S' is the documented production SKU."
    ]
  },
  "IPC-HFW2441T": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW2441T-AS_S0_datasheet_20231012.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "3.6mm / 6mm / 8mm",
      "hfov_deg": 84,
      "irRange_m": 80,
      "minIllumination_lux": 0.006,
      "minIlluminationColorLux": 0.006,
      "minIlluminationBwLux": 0.0006,
      "minIlluminationColorConditions": "F1.6, 30 IRE",
      "minIlluminationBwConditions": "F1.6, 30 IRE",
      "minIlluminationApertureF": 1.6,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 8.3,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Bare 'IPC-HFW2441T' likely refers to -AS (4 IR LED, 80m IR) variant.",
      "HFOV 84 deg @ 3.6mm; 52 deg @ 6mm; 40 deg @ 8mm.",
      "Max power 7W DC / 8.3W PoE.",
      "IK10 marked as optional in datasheet."
    ]
  },
  "IPC-HFW2441T-AS": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW2441T-AS_S0_datasheet_20231012.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "3.6mm / 6mm / 8mm",
      "hfov_deg": 84,
      "irRange_m": 80,
      "minIllumination_lux": 0.006,
      "minIlluminationColorLux": 0.006,
      "minIlluminationBwLux": 0.0006,
      "minIlluminationColorConditions": "F1.6, 30 IRE",
      "minIlluminationBwConditions": "F1.6, 30 IRE",
      "minIlluminationApertureF": 1.6,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 8.3,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "4 IR LEDs, 80m IR, alarm I/O, audio I/O.",
      "HFOV 84/52/40 for 3.6/6/8mm focal lengths."
    ]
  },
  "IPC-HFW2441T-ZAS": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW2441T-ZS_S0_datasheet_20230224.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 104,
      "irRange_m": 60,
      "minIllumination_lux": 0.006,
      "minIlluminationColorLux": 0.006,
      "minIlluminationBwLux": 0.0006,
      "minIlluminationColorConditions": "F1.5, 30 IRE",
      "minIlluminationBwConditions": "F1.5, 30 IRE",
      "minIlluminationApertureF": 1.5,
      "maxBitrate_mbps": 6.144,
      "powerConsumption_w": 10.2,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 12,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Motorized varifocal 2.7-13.5mm. HFOV 104 deg wide / 29 deg tele.",
      "60m IR (2 IR LEDs).",
      "Max power 8.8W DC / 10.2W PoE (-ZAS variant with audio/alarm).",
      "Min illum 0.006 lux@F1.5 color."
    ]
  },
  "IPC-HFW2841T": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW2841S-S_datasheet_20220919.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 95,
      "irRange_m": 30,
      "minIllumination_lux": 0.009,
      "minIlluminationColorLux": 0.009,
      "minIlluminationBwLux": 0.0009,
      "minIlluminationColorConditions": "F2.0, 30 IRE",
      "minIlluminationBwConditions": "F2.0, 30 IRE",
      "minIlluminationApertureF": 2,
      "maxBitrate_mbps": 8.192,
      "powerConsumption_w": 6.4,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Specs from IPC-HFW2841S-S datasheet (closest documented 8MP WizSense 2-series bullet).",
      "Min illum 0.009 lux@F2.0 color; 0.0009 lux B/W. Note: aperture is F2.0 not F1.6 — lower light gathering than the 4MP siblings.",
      "Max video bitrate H.265 8192 kbps. 4K@20fps; 4MP@30fps."
    ]
  },
  "IPC-HFW3441T": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/IPC-HFW3441T-ZAS-S2_S2_datasheet_20230803.pdf",
      "https://gfx3.senetic.com/akeneo-catalog/5/b/4/6/5b46b142d798a41545a79a256d64dc79fa8ae02c_IPC_HFW3441T_AS_P_S0_datasheet_20240104.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 104,
      "irRange_m": 60,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8.192,
      "powerConsumption_w": 9.2,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.15,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "WizSense 3-series 4MP bullet. Bare 'IPC-HFW3441T' likely refers to -ZAS-S2 (varifocal) variant.",
      "Adds AI Coding (AI H.265/H.264), AI SSA, SMD 4.0 vs 2-series.",
      "Max bitrate H.265 8192 kbps.",
      "Max power 7.9W DC / 9.2W PoE (varifocal motorized lens draws more).",
      "Low-light backfill withheld: the only source is a distributor mirror, which is a copy of the datasheet of unknown fidelity."
    ]
  },
  "IPC-HFW3849T1": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://gfx3.senetic.com/akeneo-catalog/e/1/5/e/e15ee0c727179a49421ec826b774574543230ca9_IPC_HFW3849T1_AS_PV_S5_datasheet_20231129.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 106,
      "irRange_m": 30,
      "minIllumination_lux": 0.004,
      "maxBitrate_mbps": 16.384,
      "powerConsumption_w": 12,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 33,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Inventory 'IPC-HFW3849T1' is bare lens base; production SKU is -AS-PV (Active Deterrence TiOC).",
      "TiOC variant has dual IR + warm light (30m each), red/blue strobe, dual mic + speaker for two-way deterrence.",
      "Min illum 0.004 lux@F1.0 color; 0.0004 lux B/W (Full Color class).",
      "Max bitrate H.265 16384 kbps. Power consumption with active deterrence active is ~12W estimate.",
      "Low-light backfill withheld: the only source is a distributor mirror, which is a copy of the datasheet of unknown fidelity."
    ]
  },
  "IPC-HFW3849T1-AS-PV": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://gfx3.senetic.com/akeneo-catalog/e/1/5/e/e15ee0c727179a49421ec826b774574543230ca9_IPC_HFW3849T1_AS_PV_S5_datasheet_20231129.pdf",
      "https://www.dahuasecurity.com/products/network-products/network-cameras/WizSense-Series/3-Series/TiOC/IPC-HFW3849T1-AS-PV=S5"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 106,
      "irRange_m": 30,
      "minIllumination_lux": 0.004,
      "maxBitrate_mbps": 16.384,
      "powerConsumption_w": 12,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 33,
      "encoderLatency_ms": 150
    },
    "notes": [
      "TiOC = Three-in-One Camera (Vision + Active Deterrence + Audio). Dual IR + dual warm light.",
      "Red/blue strobe + speaker for siren active deterrence.",
      "Min illum 0.004 lux@F1.0 color (full-color starlight).",
      "Low-light backfill withheld: the only source is a distributor mirror, which is a copy of the datasheet of unknown fidelity."
    ]
  },
  "IPC-HFW3849T1-AS-PV-ANZ": {
    "manufacturer": "Dahua",
    "status": "inferred",
    "sources": [
      "https://material.dahuasecurity.com/uploads/soft/20221214/DH-IPC-HFW3849T1-AS-PV-ANZ_datasheet_20220926.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm / 3.6mm",
      "hfov_deg": 106,
      "irRange_m": 30,
      "minIllumination_lux": 0.004,
      "maxBitrate_mbps": 16.384,
      "powerConsumption_w": 12,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264H",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 33,
      "encoderLatency_ms": 150
    },
    "notes": [
      "ANZ suffix = Australia/NZ regional SKU. Specs identical to base IPC-HFW3849T1-AS-PV.",
      "Inferred from regional datasheet existence; base specs apply."
    ]
  },
  "IPC-PFW8800": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://www.dahuasecurity.com/asset/upload/download/dh-ipc-pfw8800-a180_datasheet_20170622.pdf",
      "https://dahuawiki.com/images/Files/Specifications/Datasheet_MultiSensor_Camera_DH-IPC-PFW8800N-A180_v001_010.pdf"
    ],
    "type": "panoramic-multisensor",
    "spec": {
      "resolution": "4096x1800",
      "megapixels": 8,
      "sensorSize": "4x 1/2.8\"",
      "focalLength": "3mm",
      "hfov_deg": 180,
      "irRange_m": 30,
      "minIllumination_lux": 0.007,
      "maxBitrate_mbps": 16.384,
      "powerConsumption_w": 25,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "maxTotalBandwidth_mbps": 33,
      "encoderLatency_ms": 150
    },
    "notes": [
      "4x 1/2.8\" 2MP STARVIS sensors stitched to 4096x1800 panoramic 180-degree.",
      "Min illum 0.007 lux@F2.0 color (Starlight); 0 lux with IR on.",
      "Max IR distance 30m. Power consumption ~25W estimated for 4-sensor array w/ heater (PoE+ required).",
      "Smart H.265+, 6kV TVS lightning protection."
    ]
  },
  "IPC2124LB-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Easy_Series/EasyBasic_Series/IPC2124LB-ADF28KM-H/",
      "https://download.discomp.cz/UNV/Datasheets/IPC2124LB-ADF28(40)KM-H.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.01,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 5.5,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "environmentalClass": "III",
      "operatingTemp_min_c": -10,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Easy series 4MP fixed-lens bullet, 120 dB WDR",
      "PoE 802.3af or 12V DC",
      "microSD up to 256GB",
      "Low-light backfill withheld: the only source is a distributor mirror, which is a copy of the datasheet of unknown fidelity."
    ]
  },
  "IPC2124LB-ADF28KM-H": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Easy_Series/EasyBasic_Series/IPC2124LB-ADF28KM-H/"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.01,
      "minIlluminationColorLux": 0.01,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 5.5,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "-H suffix denotes 'Hybrid' / improved housing variant; specs identical to base"
    ]
  },
  "IPC2124LB-ADF40KM": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [
      "https://download.discomp.cz/UNV/Datasheets/IPC2124LB-ADF28(40)KM-H.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "4.0mm",
      "hfov_deg": 79,
      "irRange_m": 30,
      "minIllumination_lux": 0.01,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 5.5,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "environmentalClass": "III",
      "operatingTemp_min_c": -10,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "4mm-lens variant of IPC2124LB; HFOV ~79 typical for 4mm/4MP/1-3 sensor",
      "Low-light backfill withheld: the only source is a distributor mirror, which is a copy of the datasheet of unknown fidelity."
    ]
  },
  "IPC2124SR-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Prime_Series/"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 50,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime series 4MP bullet, longer IR than Easy LB",
      "Specs inferred from Prime SR family pattern"
    ]
  },
  "IPC2124SR3-ADF": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "bullet",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 98,
      "irRange_m": 50,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 12,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime series 4MP motorized varifocal bullet (2.8-12mm common)",
      "Specs inferred from SR3 product line"
    ]
  },
  "IPC2124SR3-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "bullet",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 50,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 9,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime series 4MP fixed-lens bullet with extended IR",
      "Inferred from family naming pattern"
    ]
  },
  "IPC2128SB-ADF": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Prime_Series/PRIMEI_Series/IPC2128SB-ADF28KM-I0/"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.0025,
      "minIlluminationColorLux": 0.0025,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime I 8MP LightHunter bullet (base SKU prior to KM/I0 suffixes)",
      "Specs derived from sibling IPC2128SB-ADF28KM-I0",
      "Minimum illumination corrected from 0.003 lx to 0.0025 lx from the manufacturer datasheet (conditions not stated); the previous figure carried no measurement conditions."
    ]
  },
  "IPC2128SB-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://global.uniview.com/res/202211/10/20221110_1861469_UNV%20%E3%80%90Datasheet%E3%80%91IPC2128SB-ADF28(40)KM-I0%208MP%20HD%20Intelligent%20LightHunter%20IR%20Fixed%20Bullet%20Network%20Camera%20datasheet%20V1.2-EN_954924_168459_0.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.0025,
      "minIlluminationColorLux": 0.0025,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime I 8MP LightHunter bullet, 4K@20fps native",
      "120 dB WDR; smart intrusion analytics",
      "Minimum illumination corrected from 0.003 lx to 0.0025 lx from the manufacturer datasheet (conditions not stated); the previous figure carried no measurement conditions."
    ]
  },
  "IPC2128SB-ADF28KM-I0": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://global.uniview.com/res/202211/10/20221110_1861469_UNV%20%E3%80%90Datasheet%E3%80%91IPC2128SB-ADF28(40)KM-I0%208MP%20HD%20Intelligent%20LightHunter%20IR%20Fixed%20Bullet%20Network%20Camera%20datasheet%20V1.2-EN_954924_168459_0.pdf"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.0025,
      "minIlluminationColorLux": 0.0025,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "I0 suffix = built-in mic + alarm I/O",
      "Prime I 8MP LightHunter, identical optics/sensor to non-I0",
      "Minimum illumination corrected from 0.003 lx to 0.0025 lx from the manufacturer datasheet (conditions not stated); the previous figure carried no measurement conditions."
    ]
  },
  "IPC2128SR3-ADF": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 109,
      "irRange_m": 50,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 12,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime series 8MP motorized-varifocal bullet (older Prime III gen)",
      "Specs inferred from SR3 product family"
    ]
  },
  "IPC2128SR3-DPF40": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "4.0mm",
      "hfov_deg": 86,
      "irRange_m": 50,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 9,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime SR3 4mm fixed-lens 8MP bullet",
      "DPF naming = Day-light/Polish-Finish; inferred"
    ]
  },
  "IPC2128SR5-ADF28KM-GC": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "irRange_m": 50,
      "minIllumination_lux": 0.0005,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 12,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime series SR5 ColorHunter (GC) 8MP bullet — full-color low-light with white LED",
      "1/1.8\" sensor for ColorHunter performance",
      "Specs inferred from SR5/GC family pattern"
    ]
  },
  "IPC3614LB-ADF28K": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Easy_Series/EasyBasic_Series/IPC3614LB-ADF28K-H/"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.01,
      "minIlluminationColorLux": 0.01,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "environmentalClass": "III",
      "operatingTemp_min_c": -10,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Easy series 4MP fixed-lens turret/eyeball",
      "WDR >52 dB, 120 dB DR"
    ]
  },
  "IPC3614LB-ADF28K-H": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Easy_Series/EasyBasic_Series/IPC3614LB-ADF28K-H/"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.01,
      "minIlluminationColorLux": 0.01,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "-H = improved housing; otherwise identical to base IPC3614LB-ADF28K"
    ]
  },
  "IPC3614LB-ADF40K": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "4.0mm",
      "hfov_deg": 79,
      "irRange_m": 30,
      "minIllumination_lux": 0.01,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "environmentalClass": "III",
      "operatingTemp_min_c": -10,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "4mm-lens variant of IPC3614LB-ADF28K"
    ]
  },
  "IPC3614SB-ADF": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Prime_Series/"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.003,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime I 4MP LightHunter turret base SKU",
      "Specs inferred from sibling IPC3614SB-ADF28KM"
    ]
  },
  "IPC3614SB-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Prime_Series/PRIMEI_Series/"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.003,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime I 4MP LightHunter turret with 120 dB WDR",
      "Smart intrusion + face detection metadata"
    ]
  },
  "IPC3614SB-ADF28KM-I0": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://www.uniview.com/Products/Network_Cameras/Prime_Series/PRIMEI_Series/"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.003,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "I0 = built-in mic + alarm I/O variant of IPC3614SB-ADF28KM"
    ]
  },
  "IPC3614SR3-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Older Prime III/SR3 turret 4MP",
      "Specs inferred from SR3 family"
    ]
  },
  "IPC3614SR3-ADPF28": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "turret",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/3\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 8,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime III SR3 ADPF (alarm + PoE-fed) 4MP turret",
      "Inferred from SR3 product line"
    ]
  },
  "IPC3615SR3-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "turret",
    "spec": {
      "resolution": "2880x1620",
      "megapixels": 5,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 105,
      "irRange_m": 30,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 12,
      "powerConsumption_w": 7,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime III SR3 5MP turret",
      "Inferred from family pattern (1361X = 5MP variant)"
    ]
  },
  "IPC3618SR3-ADF28KM": {
    "manufacturer": "Uniview",
    "status": "inferred",
    "sources": [],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.005,
      "maxBitrate_mbps": 16,
      "powerConsumption_w": 8,
      "ipRating": "IP67",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 1.64,
      "maxTotalBandwidth_mbps": 32,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Prime III SR3 8MP turret",
      "Inferred from family pattern (1361X = 8MP variant)"
    ]
  },
  "IPC675LFW-AX4DUPKC": {
    "manufacturer": "Uniview",
    "status": "verified",
    "sources": [
      "https://global.uniview.com/res/202308/09/20230809_1885114_UNV%20%E3%80%90Datasheet%E3%80%91%20IPC675LFW-AX4DUPKC-VG%205MP%20LightHunter%20Active%20Deterrence%20Mini%20PTZ%20Camera%20V1.7-EN_893556_168459_0.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "2880x1620",
      "megapixels": 5,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 104.1,
      "irRange_m": 50,
      "minIllumination_lux": 0.002,
      "minIlluminationColorLux": 0.002,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 12,
      "powerConsumption_w": 18,
      "ipRating": "IP66",
      "ikRating": "none",
      "codecsSupported": [
        "Ultra265",
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 4,
      "pixelPitch_um": 2.08,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 120
    },
    "notes": [
      "5MP LightHunter Active Deterrence Mini PTZ (-VG variant most common)",
      "4x optical zoom (2.8-12mm), HFOV 104.1 wide / 30.6 tele",
      "Built-in white LED warm light to 10m + audible alarm + two-way audio",
      "120 dB WDR, auto-tracking"
    ]
  },
  "NBE-7604-AL": {
    "manufacturer": "Bosch",
    "status": "verified",
    "sources": [
      "https://netcamcenter.com/en/products/ip-cameras/nbe-7604-al",
      "https://www.bhphotovideo.com/c/product/1297121-REG/bosch_f_01u_314_818_flexidome_ip_starlight_7000.html"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "3.2-10.5mm",
      "hfov_deg": 100,
      "irRange_m": 60,
      "minIllumination_lux": 0.014,
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 16,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -50,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 130
    },
    "notes": [
      "Inteox 7100i 8MP IR vandal bullet (open OS platform for 3rd-party apps)",
      "87 dB starlight WDR, day/night",
      "Now end-of-life per netcamcenter; product redirects from boschsecurity.com to keenfinity-group.com"
    ]
  },
  "NDP-7604-Z30": {
    "manufacturer": "Bosch",
    "status": "unknown",
    "sources": [],
    "type": "ptz",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "5-150mm",
      "hfov_deg": 60,
      "irRange_m": 200,
      "minIllumination_lux": 0.05,
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 60,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 60,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 100
    },
    "notes": [
      "Could not verify 'NDP-7604-Z30' as a real Bosch SKU — the 7604 family pairs with Z12L (12x) for 8MP, and Z30 lens module is published only on 7602 (2MP)",
      "Specs are best-guess based on AUTODOME 7100i 8MP family with hypothetical 30x lens module",
      "Recommend re-checking the model name in cameras.ts"
    ]
  },
  "NDV-3502-F": {
    "manufacturer": "Bosch",
    "status": "verified",
    "sources": [
      "https://commerce.boschsecurity.com/xl/en/FLEXIDOME-IP-micro-3000i-indoor/p/F.01U.386.150/",
      "https://icecat.biz/en/p/bosch/ndv-3502-f02/flexidome-security+cameras-flexidome+ip+micro+3000i-75688112.html"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.3mm",
      "hfov_deg": 130,
      "irRange_m": 0,
      "minIllumination_lux": 0.18,
      "maxBitrate_mbps": 10,
      "powerConsumption_w": 4.5,
      "ipRating": "IP20",
      "ikRating": "IK08",
      "codecsSupported": [
        "H.265",
        "H.264"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "I",
      "operatingTemp_min_c": -20,
      "operatingTemp_max_c": 50,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 3.04,
      "maxTotalBandwidth_mbps": 20,
      "encoderLatency_ms": 130
    },
    "notes": [
      "FlexiDome IP micro 3000i indoor fixed micro-dome, 2MP HDR",
      "130 deg ultra-wide fixed lens (typical F02 variant)",
      "Indoor only (no IP65/66) — IP20 housing; IK08 vandal",
      "Essential Video Analytics on-board"
    ]
  },
  "PND-A9081RV": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/pnd-a9081rv/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "4.5-10mm",
      "hfov_deg": 101.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.05,
      "minIlluminationColorLux": 0.05,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 20,
      "ipRating": "IP52",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "II",
      "operatingTemp_min_c": -10,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Indoor vandal AI dome on WiseNet 7 SoC",
      "HFOV 101.4 wide / 45.5 tele (motorized 2.2x zoom)",
      "Edge AI: person/face/vehicle/LPR + analytics",
      "maxBitrate not published in datasheet; 25 Mbps is typical 4K H.265 ceiling for WiseNet 7"
    ]
  },
  "PNM-9322VQP": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/pnm-9322vqp/"
    ],
    "type": "multi-sensor-ptz",
    "spec": {
      "resolution": "multi-sensor",
      "megapixels": 10,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.4-12mm + 4.44-142.6mm PTZ",
      "hfov_deg": 112,
      "irRange_m": 0,
      "minIllumination_lux": 0.3,
      "maxBitrate_mbps": 50,
      "powerConsumption_w": 65,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -50,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 1.42,
      "maxTotalBandwidth_mbps": 100,
      "encoderLatency_ms": 100
    },
    "notes": [
      "Multi-directional 4-channel + 1 PTZ (32x zoom)",
      "Total 8MP-20MP depending on lens module mix (4x 2MP/5MP fixed + 2MP PTZ)",
      "PTZ HFOV 61.8 wide / 2.19 tele",
      "No IR, designed for daytime/lit perimeters",
      "Power via HPoE only (max 65W)"
    ]
  },
  "PNV-A9081R": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/pnv-a9081r/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "4.5-10mm",
      "hfov_deg": 101.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.05,
      "minIlluminationColorLux": 0.05,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 17,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10+",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Outdoor 4K AI vandal dome, WiseNet 7 SoC",
      "IP6K9K + NEMA4X + IK10+ (super-rugged)",
      "Edge AI: person/face/vehicle/LPR/heatmap"
    ]
  },
  "PNV-A9081RLP": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavision.com/en/products/camera/network/dome/pnv-a9081rlp/",
      "https://hanwhavision.eu/product/pnv-a9081rlp/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "4.5-10mm",
      "hfov_deg": 101.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.05,
      "minIlluminationColorLux": 0.05,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 17,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10+",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "LPR variant of PNV-A9081R with Wisenet Road AI pre-installed",
      "License plate detection up to 70 km/h (45 mph)",
      "32GB microSD pre-installed for LPR captures",
      "ONVIF G/S/T"
    ]
  },
  "PNV-A9081RX": {
    "manufacturer": "Hanwha",
    "status": "unknown",
    "sources": [],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/1.8\"",
      "focalLength": "4.5-10mm",
      "hfov_deg": 101.4,
      "irRange_m": 30,
      "minIllumination_lux": 0.05,
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 17,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10+",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.19,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Could not verify PNV-A9081RX as a real Hanwha SKU on hanwhavisionamerica.com or hanwha-security.com",
      "Specs cloned from sibling PNV-A9081R as best-guess; treat with caution",
      "Possible regional/explosion-proof variant naming or listing error"
    ]
  },
  "SD49225XA-HNR": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://material.dahuasecurity.com/uploads/soft/20230223/DH-SD49225XA-HNR_datasheet_20220711.pdf",
      "https://www.dahuasecurity.com/asset/upload/uploads/cpq/DH-SD49225XA-HNR_datasheet_20200604.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.8-120mm",
      "hfov_deg": 58.5,
      "irRange_m": 100,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "maxBitrate_mbps": 8.192,
      "powerConsumption_w": 20,
      "ipRating": "IP66",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 70,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 16,
      "encoderLatency_ms": 100
    },
    "notes": [
      "2MP 25x optical zoom Starlight WizSense PTZ.",
      "HFOV 58.5 deg wide / 2.8 deg tele. Min illum 0.005 lux@F1.6 color.",
      "Max power 20W with IR on; basic 12W. PoE+ (802.3at) required.",
      "100m IR range, 3 IR LEDs."
    ]
  },
  "SD49425XB-HNR": {
    "manufacturer": "Dahua",
    "status": "verified",
    "sources": [
      "https://www.dahuasecurity.com/asset/upload/uploads/soft/20191029/DH-SD49425XB-HNR-G_Datasheet.pdf",
      "https://www.dahuasecurity.com/asset/upload/uploads/soft/20220324/DH-SD49425XB-HNR-G_datasheet_20200605.pdf"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "2560x1440",
      "megapixels": 4,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.8-120mm",
      "hfov_deg": 60,
      "irRange_m": 100,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "maxBitrate_mbps": 20.48,
      "powerConsumption_w": 21,
      "ipRating": "IP66",
      "codecsSupported": [
        "H.265",
        "H.264",
        "H.264B",
        "MJPEG"
      ],
      "ndaaCompliant": false,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -40,
      "operatingTemp_max_c": 70,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.24,
      "maxTotalBandwidth_mbps": 41,
      "encoderLatency_ms": 100
    },
    "notes": [
      "4MP 25x optical zoom STARVIS Starlight WizSense PTZ.",
      "HFOV 60 deg wide / 2.5 deg tele. Min illum 0.005 lux@F1.6 color; 0.0005 lux B/W.",
      "Max bitrate H.265 20480 kbps.",
      "Max power 21W with IR; basic 13W. PoE+ (802.3at) required.",
      "100m IR range. Note: -G suffix is the 4G/cellular version; bare HNR is wired."
    ]
  },
  "XND-6080R": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/xnd-6080r/",
      "https://www.hanwha-security.com/en/products/camera/network/dome/xnd-6080r/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 119.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.015,
      "maxBitrate_mbps": 12,
      "powerConsumption_w": 11,
      "ipRating": "IP52",
      "ikRating": "IK08",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "II",
      "operatingTemp_min_c": -10,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Indoor 2MP IR dome (Wisenet X series)",
      "Motorized varifocal 4.3x zoom; 60fps at all resolutions",
      "WDR 150 dB, Defog"
    ]
  },
  "XND-6080RV": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/xnd-6080rv/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 119.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.015,
      "maxBitrate_mbps": 12,
      "powerConsumption_w": 11,
      "ipRating": "IP52",
      "ikRating": "IK08",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "II",
      "operatingTemp_min_c": -10,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 0,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Vandal-resistant indoor variant of XND-6080R",
      "Same optics/sensor; differs in housing"
    ]
  },
  "XNO-6080R": {
    "manufacturer": "Hanwha",
    "status": "inferred",
    "sources": [
      "https://www.hanwha-security.com/en/products/camera/network/bullet/xno-6080r/"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 119.5,
      "irRange_m": 30,
      "minIllumination_lux": 0.015,
      "maxBitrate_mbps": 12,
      "powerConsumption_w": 12.5,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Outdoor 2MP IR bullet, Wisenet X family (sibling to XND-6080R)",
      "Specs inferred from family pattern; numeric values consistent with platform"
    ]
  },
  "XNO-8080R": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/xno-8080r/"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2560x1920",
      "megapixels": 5,
      "sensorSize": "1/1.8\"",
      "focalLength": "3.7-9.4mm",
      "hfov_deg": 100.2,
      "irRange_m": 50,
      "minIllumination_lux": 0.07,
      "maxBitrate_mbps": 20,
      "powerConsumption_w": 12.95,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.77,
      "maxTotalBandwidth_mbps": 40,
      "encoderLatency_ms": 150
    },
    "notes": [
      "5MP outdoor IR bullet, 1/1.8\" 6MP sensor, NEMA 4X",
      "30fps at all resolutions in H.265/H.264"
    ]
  },
  "XNP-6320H": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/xnp-6320h/"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "4.44-142.6mm",
      "hfov_deg": 61.8,
      "irRange_m": 0,
      "minIllumination_lux": 0.05,
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 65,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -50,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 100
    },
    "notes": [
      "32x optical zoom 2MP PTZ (no IR); HFOV 61.8 wide / 2.19 tele",
      "WDR 150 dB; 60fps H.265/H.264",
      "Discontinued - replacement is XNP-6400"
    ]
  },
  "XNP-9300RW": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/xnp-9300rw/"
    ],
    "type": "ptz",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8,
      "sensorSize": "1/2.8\"",
      "focalLength": "5-150mm",
      "hfov_deg": 57.42,
      "irRange_m": 200,
      "minIllumination_lux": 0.1,
      "maxBitrate_mbps": 25,
      "powerConsumption_w": 42,
      "ipRating": "IP66",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "III",
      "operatingTemp_min_c": -50,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 1.58,
      "maxTotalBandwidth_mbps": 50,
      "encoderLatency_ms": 100
    },
    "notes": [
      "4K 30x zoom AI PTZ with 200m IR and integrated wiper",
      "AI auto-tracking (person/vehicle)",
      "HFOV 57.42 wide / 2.19 tele"
    ]
  },
  "XNV-6080R": {
    "manufacturer": "Hanwha",
    "status": "verified",
    "sources": [
      "https://www.hanwhavisionamerica.com/product/xnv-6080r/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 119.5,
      "irRange_m": 50,
      "minIllumination_lux": 0.015,
      "maxBitrate_mbps": 12,
      "powerConsumption_w": 12.95,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Outdoor 2MP IR vandal dome (Wisenet X), 60fps all resolutions",
      "WDR 150 dB"
    ]
  },
  "XNV-6080RSA": {
    "manufacturer": "Hanwha",
    "status": "inferred",
    "sources": [
      "https://www.hanwha-security.com/en/products/camera/network/dome/xnv-6080rsa/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "1920x1080",
      "megapixels": 2,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8-12mm",
      "hfov_deg": 119.5,
      "irRange_m": 50,
      "minIllumination_lux": 0.015,
      "maxBitrate_mbps": 12,
      "powerConsumption_w": 12.95,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 3.16,
      "maxTotalBandwidth_mbps": 24,
      "encoderLatency_ms": 150
    },
    "notes": [
      "Stainless-steel housing variant of XNV-6080R for marine/corrosive environments",
      "Optical/sensor specs identical to XNV-6080R"
    ]
  },
  "XNV-8080R": {
    "manufacturer": "Hanwha",
    "status": "inferred",
    "sources": [
      "https://www.hanwha-security.com/en/products/camera/network/dome/xnv-8080r/"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2560x1920",
      "megapixels": 5,
      "sensorSize": "1/1.8\"",
      "focalLength": "3.7-9.4mm",
      "hfov_deg": 100.2,
      "irRange_m": 50,
      "minIllumination_lux": 0.07,
      "maxBitrate_mbps": 20,
      "powerConsumption_w": 12.95,
      "ipRating": "IP66/IP67",
      "ikRating": "IK10",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "ndaaCompliant": true,
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ],
      "emcCompliant_EN50130_4": true,
      "environmentalClass": "IV",
      "operatingTemp_min_c": -30,
      "operatingTemp_max_c": 55,
      "surgeProtection_kV": 6,
      "pixelPitch_um": 2.77,
      "maxTotalBandwidth_mbps": 40,
      "encoderLatency_ms": 150
    },
    "notes": [
      "5MP outdoor IR vandal dome (Wisenet X), dome sibling to XNO-8080R",
      "Specs aligned with XNO-8080R, same SoC platform"
    ]
  },
  "N3T-5DA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3T-5DA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2960x1668",
      "megapixels": 4.9,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 111,
      "irRange_m": 31,
      "vfov_deg": 58,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 5MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3T-4LA2B": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3T-4LA2B"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm",
      "hfov_deg": 95,
      "irRange_m": 31,
      "vfov_deg": 52,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3T-8LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3T-8LAV"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 114,
      "irRange_m": 40,
      "vfov_deg": 58,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.5",
      "minIlluminationBwConditions": "F1.5",
      "minIlluminationApertureF": 1.5,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 39.6 m",
      "PoE 802.3af"
    ]
  },
  "N4T-8VA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N4T-8VA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0003,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "white-light illumination to 30 m",
      "PoE 802.3af",
      "Datasheet states a colour minimum illumination only; this is a white-light model whose monochrome mode has no published figure. Deliberately not backfilled."
    ]
  },
  "N4B-8VA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N4B-8VA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 50,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0003,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "white-light illumination to 50 m",
      "PoE 802.3af",
      "Datasheet states a colour minimum illumination only; this is a white-light model whose monochrome mode has no published figure. Deliberately not backfilled."
    ]
  },
  "N3W-4LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3W-4LA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm",
      "hfov_deg": 95,
      "irRange_m": 31,
      "vfov_deg": 52,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3T-4LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3T-4LAV"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 97,
      "irRange_m": 40,
      "vfov_deg": 52,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 39.6 m",
      "PoE 802.3af"
    ]
  },
  "N9P-4RA2": {
    "manufacturer": "Luminys",
    "status": "inferred",
    "sources": [
      "https://www.luminyscorp.com/products/N9P-4RA2"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101,
      "irRange_m": 31,
      "vfov_deg": 120,
      "minIllumination_lux": 0.0007,
      "minIlluminationColorLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "monoIsIrAssistedZero": true,
      "supplementaryLight": "ir",
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 4MP Progressive-scan CMOS",
      "Vertical angle 120°",
      "IR illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3B-8LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3B-8LA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 31,
      "vfov_deg": 58,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3B-4LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3B-4LA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm",
      "hfov_deg": 95,
      "irRange_m": 31,
      "vfov_deg": 52,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3B-8LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3B-8LAV"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 114,
      "irRange_m": 61,
      "vfov_deg": 58,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 61 m",
      "PoE 802.3af"
    ]
  },
  "N3B-4LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3B-4LAV"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 97,
      "irRange_m": 61,
      "vfov_deg": 52,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.5",
      "minIlluminationBwConditions": "F1.5",
      "minIlluminationApertureF": 1.5,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 61 m",
      "PoE 802.3af"
    ]
  },
  "N3D-8LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3D-8LAV"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 114,
      "irRange_m": 61,
      "vfov_deg": 58,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 61 m",
      "PoE 802.3af"
    ]
  },
  "N3D-4LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3D-4LAV"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 97,
      "irRange_m": 40,
      "vfov_deg": 52,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.5",
      "minIlluminationBwConditions": "F1.5",
      "minIlluminationApertureF": 1.5,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 39.6 m",
      "PoE 802.3af"
    ]
  },
  "N3D-8LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3D-8LA2"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 31,
      "vfov_deg": 58,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3D-4LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3D-4LA2"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm",
      "hfov_deg": 95,
      "irRange_m": 31,
      "vfov_deg": 52,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3T-8LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3T-8LA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 31,
      "vfov_deg": 58,
      "minIllumination_lux": 0.007,
      "minIlluminationColorLux": 0.007,
      "minIlluminationBwLux": 0.0007,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N3T-4LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3T-4LA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/2.9\"",
      "focalLength": "2.8mm",
      "hfov_deg": 95,
      "irRange_m": 31,
      "vfov_deg": 52,
      "minIllumination_lux": 0.005,
      "minIlluminationColorLux": 0.005,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.9-in. 4MP Progressive-scan CMOS",
      "Vertical angle 52°",
      "IR and white-light illumination to 30.5 m",
      "PoE 802.3af"
    ]
  },
  "N4B-4VA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N4B-4VA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "irRange_m": 46,
      "vfov_deg": 60,
      "minIllumination_lux": 0.0006,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 60°",
      "white-light illumination to 45.7 m",
      "PoE 802.3af",
      "Datasheet states a colour minimum illumination only; this is a white-light model whose monochrome mode has no published figure. Deliberately not backfilled."
    ]
  },
  "N5T-8DA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-8DA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 106,
      "irRange_m": 30,
      "vfov_deg": 55,
      "minIllumination_lux": 0.001,
      "minIlluminationColorLux": 0.001,
      "minIlluminationBwLux": 0.0001,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 55°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3af"
    ]
  },
  "N9F-12RA1": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N9F-12RA1"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "4000x3000",
      "megapixels": 12,
      "sensorSize": "1/1.7\"",
      "focalLength": "1.85mm",
      "hfov_deg": 185,
      "irRange_m": 10,
      "vfov_deg": 180,
      "minIllumination_lux": 0.01,
      "minIlluminationColorLux": 0.01,
      "minIlluminationBwLux": 0.001,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.7-in. 12MP Progressive-scan CMOS",
      "Vertical angle 180°",
      "IR and white-light illumination to 10 m"
    ]
  },
  "N5T-8CA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-8CA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0005,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5B-8CA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5B-8CA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0005,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5T-4CA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-4CA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0005,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5B-4CA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5B-4CA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "irRange_m": 30,
      "vfov_deg": 60,
      "minIllumination_lux": 0.0005,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 60°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5P-8DA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5P-8DA2"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "4096x1860",
      "megapixels": 7.6,
      "sensorSize": "1/2.7\"",
      "focalLength": "2.8mm",
      "hfov_deg": 180,
      "irRange_m": 25,
      "vfov_deg": 86,
      "minIllumination_lux": 0.002,
      "minIlluminationColorLux": 0.002,
      "minIlluminationBwLux": 0.0002,
      "minIlluminationColorConditions": "F1.4",
      "minIlluminationBwConditions": "F1.4",
      "minIlluminationApertureF": 1.4,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.7-in. 4MP Progressive-scan CMOS",
      "Vertical angle 86°",
      "IR illumination to 25 m",
      "PoE 802.3af"
    ]
  },
  "N5T-8DAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-8DAV"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.7-13.5mm",
      "hfov_deg": 108,
      "irRange_m": 50,
      "vfov_deg": 56,
      "minIllumination_lux": 0.002,
      "minIlluminationColorLux": 0.002,
      "minIlluminationBwLux": 0.0002,
      "minIlluminationColorConditions": "F1.0",
      "minIlluminationBwConditions": "F1.0",
      "minIlluminationApertureF": 1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 56°",
      "IR illumination to 50 m",
      "PoE 802.3af"
    ]
  },
  "N5T-4DA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-4DA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 101,
      "irRange_m": 30,
      "vfov_deg": 53,
      "minIllumination_lux": 0.001,
      "minIlluminationColorLux": 0.001,
      "minIlluminationBwLux": 0.0001,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 53°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3af"
    ]
  },
  "N5T-12LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-12LA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "4512x2512",
      "megapixels": 11.3,
      "sensorSize": "1/2.5\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "irRange_m": 30,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0085,
      "minIlluminationColorLux": 0.0085,
      "minIlluminationBwLux": 0.0008,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.5-in. 12MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5D-12LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5D-12LA2"
    ],
    "type": "dome",
    "spec": {
      "resolution": "4512x2512",
      "megapixels": 11.3,
      "sensorSize": "1/2.5\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "irRange_m": 30,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0085,
      "minIlluminationColorLux": 0.0085,
      "minIlluminationBwLux": 0.0008,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.5-in. 12MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5B-12LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5B-12LA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "4512x2512",
      "megapixels": 11.3,
      "sensorSize": "1/2.5\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "irRange_m": 30,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0085,
      "minIlluminationColorLux": 0.0085,
      "minIlluminationBwLux": 0.0008,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.5-in. 12MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5B-8LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5B-8LAV"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.7-12mm",
      "hfov_deg": 112,
      "irRange_m": 50,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0007,
      "minIlluminationColorLux": 0.0007,
      "minIlluminationBwLux": 0.0004,
      "minIlluminationColorConditions": "F1.2",
      "minIlluminationBwConditions": "F1.2",
      "minIlluminationApertureF": 1.2,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 50 m",
      "PoE 802.3af"
    ]
  },
  "N5D-8LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5D-8LAV"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.7-12mm",
      "hfov_deg": 112,
      "irRange_m": 30,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0007,
      "minIlluminationColorLux": 0.0007,
      "minIlluminationBwLux": 0.0004,
      "minIlluminationColorConditions": "F1.2",
      "minIlluminationBwConditions": "F1.2",
      "minIlluminationApertureF": 1.2,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5T-8LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-8LAV"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.7-12mm",
      "hfov_deg": 112,
      "irRange_m": 40,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0007,
      "minIlluminationColorLux": 0.0007,
      "minIlluminationBwLux": 0.0004,
      "minIlluminationColorConditions": "F1.2",
      "minIlluminationBwConditions": "F1.2",
      "minIlluminationApertureF": 1.2,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 40 m",
      "PoE 802.3at"
    ]
  },
  "N5T-8LA2B": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-8LA2B"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 109,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "minIlluminationBwLux": 0.0003,
      "minIlluminationColorConditions": "F1.0",
      "minIlluminationBwConditions": "F1.0",
      "minIlluminationApertureF": 1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5T-8LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-8LA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 109,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "minIlluminationBwLux": 0.0003,
      "minIlluminationColorConditions": "F1.0",
      "minIlluminationBwConditions": "F1.0",
      "minIlluminationApertureF": 1,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5D-8LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5D-8LA2"
    ],
    "type": "dome",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 110,
      "irRange_m": 30,
      "vfov_deg": 57,
      "minIllumination_lux": 0.0008,
      "minIlluminationColorLux": 0.0008,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.4",
      "minIlluminationBwConditions": "F1.4",
      "minIlluminationApertureF": 1.4,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 57°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5B-8LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5B-8LA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 109,
      "irRange_m": 30,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "minIlluminationBwLux": 0.0003,
      "minIlluminationColorConditions": "F1.0",
      "minIlluminationBwConditions": "F1.0",
      "minIlluminationApertureF": 1,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5T-4LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-4LAV"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.7-12mm",
      "hfov_deg": 114,
      "irRange_m": 40,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0006,
      "minIlluminationColorLux": 0.0006,
      "minIlluminationBwLux": 0.0003,
      "minIlluminationColorConditions": "F1.2",
      "minIlluminationApertureF": 1.2,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 40 m",
      "PoE 802.3at"
    ]
  },
  "N5D-4LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5D-4LAV"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.7-12mm",
      "hfov_deg": 114,
      "irRange_m": 40,
      "vfov_deg": 59,
      "minIllumination_lux": 0.0006,
      "minIlluminationColorLux": 0.0006,
      "minIlluminationBwLux": 0.0003,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 59°",
      "IR and white-light illumination to 40 m",
      "PoE 802.3at"
    ]
  },
  "N5B-4LAV": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5B-4LAV"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.7-12mm",
      "hfov_deg": 112,
      "irRange_m": 30,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0006,
      "minIlluminationColorLux": 0.0006,
      "minIlluminationBwLux": 0.0003,
      "minIlluminationColorConditions": "F1.2",
      "minIlluminationBwConditions": "F1.2",
      "minIlluminationApertureF": 1.2,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at",
      "Minimum illumination corrected from 0.0007 lx to 0.0006 lx from the manufacturer datasheet (F1.2); the previous figure carried no measurement conditions."
    ]
  },
  "N5T-4LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5T-4LA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 111,
      "irRange_m": 30,
      "vfov_deg": 60,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "minIlluminationBwLux": 0.0003,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 60°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5D-4LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5D-4LA2"
    ],
    "type": "dome",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 112,
      "irRange_m": 30,
      "vfov_deg": 58,
      "minIllumination_lux": 0.0008,
      "minIlluminationColorLux": 0.0008,
      "minIlluminationBwLux": 0.0005,
      "minIlluminationColorConditions": "F1.4",
      "minIlluminationBwConditions": "F1.4",
      "minIlluminationApertureF": 1.4,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N5B-4LA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N5B-4LA2"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 111,
      "irRange_m": 30,
      "vfov_deg": 60,
      "minIllumination_lux": 0.0005,
      "minIlluminationColorLux": 0.0005,
      "minIlluminationBwLux": 0.0003,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 60°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3at"
    ]
  },
  "N9F-8RA1": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N9F-8RA1"
    ],
    "type": "panoramic",
    "spec": {
      "resolution": "3280x2480",
      "megapixels": 8.1,
      "sensorSize": "1/1.7\"",
      "focalLength": "1.85mm",
      "hfov_deg": 185,
      "irRange_m": 10,
      "vfov_deg": 180,
      "minIllumination_lux": 0.01,
      "minIlluminationColorLux": 0.01,
      "minIlluminationBwLux": 0.001,
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.7-in. 8MP Progressive-scan CMOS",
      "Vertical angle 180°",
      "IR and white-light illumination to 10 m"
    ]
  },
  "N9L-4RAL": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N9L-4RAL"
    ],
    "type": "bullet",
    "spec": {
      "resolution": "2688x1520",
      "megapixels": 4.1,
      "sensorSize": "1/1.8\"",
      "focalLength": "10-50mm",
      "hfov_deg": 41,
      "irRange_m": 30,
      "vfov_deg": 23,
      "minIllumination_lux": 0.002,
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/1.8-in. 4MP Progressive-scan CMOS",
      "Vertical angle 22.7°",
      "IR and illumination to 30 m"
    ]
  },
  "N3T-8BA2": {
    "manufacturer": "Luminys",
    "status": "verified",
    "sources": [
      "https://www.luminyscorp.com/products/N3T-8BA2"
    ],
    "type": "turret",
    "spec": {
      "resolution": "3840x2160",
      "megapixels": 8.3,
      "sensorSize": "1/2.8\"",
      "focalLength": "2.8mm",
      "hfov_deg": 111,
      "irRange_m": 30,
      "vfov_deg": 58,
      "minIllumination_lux": 0.008,
      "minIlluminationColorLux": 0.008,
      "minIlluminationBwLux": 0.0008,
      "minIlluminationColorConditions": "F1.6",
      "minIlluminationBwConditions": "F1.6",
      "minIlluminationApertureF": 1.6,
      "ipRating": "IP67",
      "codecsSupported": [
        "H.265",
        "H.264",
        "MJPEG"
      ],
      "onvifProfiles": [
        "G",
        "S",
        "T"
      ]
    },
    "notes": [
      "Sensor: 1/2.8-in. 8MP Progressive-scan CMOS",
      "Vertical angle 58°",
      "IR and white-light illumination to 30 m",
      "PoE 802.3af"
    ]
  },
  "ZN8-53B5M213T-J1": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-53E5F28NT-J4": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-53MB5F28NT-J4": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-71B5M213D": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-71DT5F28NL": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-71DT5F4NL": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-71E5F28WL": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-71E5M213D-M": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80B5M213D": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80BT4M311DL-A": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80BT4M550DL-A": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80C4D": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80DT5M213DL": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "M",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80DT8M213DL": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80F12F18NL": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-80X2B8F28DT-J4": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-MP5X5DL-J4": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8-P4X37DL": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8V-53DT5F28L-J1": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8V-53DT5M213L-J1": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8V-71B5F28DT-J4A": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZN8V-71E5F28DT-J4": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZNT8-25BQVF7-B-2": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ZNT8-25E0F36-B": {
    "manufacturer": "GANZ Security",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F2107-RE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F2135-RE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F2137-RE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F4105-LRE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F4105-SLRE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F7225-RE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M3077-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M3125-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M3126-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M3128-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M3215-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M3216-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M3905-R": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4215-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4215-V": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4216-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4216-V": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4218-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4218-V": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4225-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4227-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4228-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4308-PLE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK09"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4317-PLR": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4317-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4318-PLR": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M4318-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "M5526-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK09"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1385-BE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1387-BE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1387-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1388-BE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1388-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1468-XLE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1475-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1485-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1487-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1488-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1518-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P1518-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3268-SLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3277-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3277-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3278-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3278-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3285-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3285-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3287-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3287-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3288-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3288-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3735-PLE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK09"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3737-PLE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK09"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3738-PLE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK09"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3747-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3748-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3818-PVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3827-PVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3925-LRE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3925-R": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P3935-LR": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P4705-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P4707-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P4708-PLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P5655-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P5676-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "P9117-PV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1656-DLE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1656-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1686-DLE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1726-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1728-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1800-LE-3": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1800-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1805-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1806-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1808-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1809-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1961-TE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1971-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q1972-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q2101-TE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q2111-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q2112-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3538-SLVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3546-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3548-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3556-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3558-LVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3626-VE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3628-VE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3839-PVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q3839-SPVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q4809-PVE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6020-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6086-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6088-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6225-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6300-E": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6325-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6355-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q6358-LE": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q9227-SLV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Q9307-LV": {
    "manufacturer": "Axis",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-DA21L3B-LQ": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-EE61L2C-VMD-Q": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-TA21L6C-Q": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-TC21L5C-VMD-LQ": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-TC61L5C-VMD-LQ": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-TC81L5C-VMD-LQ": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-TC81ZL6C-VMD-LQ": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-TE81ZL6C-VMDS-Q": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-TT41L3-VMD-Q": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-VC41ZL5C-VMD-Q": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-VC61L5C-VMD-LQ": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-VC81ZL5C-VMD-Q": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CP-UNC-WE21L3C-MDS-Q": {
    "manufacturer": "CP Plus",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BF4CP-4G-XL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BP3EW-4G": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DH-HAC-HFW1209TLMP-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DH-HAC-HFW1209TMP-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD29204DB-GNY": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DH-SD49369SIP-QD": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DH-SD59430U-HNI": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DH-SDT6R324-4R-GB": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F2C-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1249X-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1249X-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1249X-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1249X-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509MH-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-EBW81230": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW2449F-AS-E2-IL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW3441DR1-AST-4G-LA": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW5441E-ZE-HDMI": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW5441F-AS-E2": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW5441R-ASE-HDMI": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW5559E1-ZE-IL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW7859Z-Z4-X": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW1230DT-SAW": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW2849T-S-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW3849H-ZAS-PV-PRO-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW1230DS1-SAW": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW2431DG-4G-SP-EAU-B": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW2431DG-4G-SP-LA-B": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW2849M-S-B-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW2849TL-S-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW3241DF-AS-4G": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW3441DG-AS-4G-EAU-B": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW3441DG-AS-4G-LA-B": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW3449T1-ZAS-PV-PRO-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW7459Z1-Z-PV-X-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW7459Z1-Z10-PV-X-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW7459Z1-Z4-PV-X-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW7859Z1-Z-PV-X-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW7859Z1-Z4-PV-X-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW7859Z1-Z7-PV-X-ATC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW8241X-3D": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "G",
        "S"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFWN542T-ZAS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-MFW5241T2-E3-ASE": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PT2449C1-ST4G-PV-EAU": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PTS2649C-3E3Z-4GB20-EAU": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PTS2649C-3E3Z-4GB20": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-UDW2269V-A-IL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-UDW2469V-A-IL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-UFW3459T-AS-IL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PSDW81642S-A360-D425": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZB2404": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD2A400HB-GN-AGQ-PV-SP-EAU": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD2A400HB-GN-AGQ-PV-SP-LA": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD2A500HB-GN-A-PV-S2": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD2C400NA-B-PV-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD3D216NB-GNY": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD3D416NB-GNY": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD5A432XB-HNR-AC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD6C3432XB-HNR-AGQ-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD8A840-HNF-PA": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SDT2A200-2F-NB-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SDT4A404-4F-QA": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "T2A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TPC-AEPT8441-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200CLQ-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1239T-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500CLQ-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500T-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1801T-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1801TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500CL-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500CM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509TM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801CM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1239TQ-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1509H-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-PT1200A-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-PT1200B-IL-A-E2Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-PT1500A-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-PTS1500C-E2-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-EBW81242-AS-S2": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-EBW8842-AS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW3441R-AS-P": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW7442E1-Z-X": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW7442E1-Z4-X": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW7842E1-Z4-X": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDBW8841H-Z-LB": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDEW8441R-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDEW8841R-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDPW5441C-AS-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW2649T-S-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW3441EM-S-S2": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW3449QM-S-IL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW8441X-BV-3D": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFE8849F-Z-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW2441DG-4G-SP-B-MAX": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW2441DG-4G-SP-B": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW5449T1-ZE-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW5859Z-ZHE-PV-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HFW7442H-Z4-X": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HUM8441E-E1-L3": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HUM8531M-V-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-MFW7442K1-Z7-T40": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-MFW7449Y-Z7-T44": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-MFW7449Y-Z7-T8A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PDW5849-A180-E2-ASTE": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PFW5849-A180-E2-ASTE": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PT1239H-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PT1439H-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PT2249C1-S-PV-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PT2449C1-S-PV-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PT2849C1-S-PV-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PTS1439B-E2-S-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PTS2449C-4E3Z-S-PV-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PSDW81642M-A180-D440-S3": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PSDW81652S-A360-D440": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PSDW82442M-A270-D440-S3": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PSDW83242M-A360-D845L-S3": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ37225-HNP-XB-A-EG": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD1A404DB-GNY": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK08",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD2A500HB-GN-AW-PV-S2": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD2A500NB-GNY-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD3A200-GN-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD3A400-GN-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD60432DB-HNY-SL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD6AL445GB-HNV-IR": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD6C3432GB-HNR-AGQ-PV1-EAU": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD8A440-HNF-PA": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD8A440FA-HNT": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD8A440GA-HNV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TPC-AEPT8641-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TPC-BF5441-AC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TPC-BF5441-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TPC-PT8441MA-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TPC-PT8641C": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TPC-SD5641": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-B1A21-U": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-B1A51-U": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-B2A21-U": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-B2A51-U": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-B3A21-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-B3A51-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-B4A21-VF": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-D3A21-VF": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-D3A21-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-D3A51-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1200EA(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1200R-Z-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1200RA-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1200RA-Z(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1231EA-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1231RA-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1231RA-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1239RA-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1500EA-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1500R-Z-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1500RA-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1500RA-Z-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1509RA-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1801RA-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW1801RA-Z-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2241EA-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2241F-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2241RA-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2241RA-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2241RA-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501E": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501EA-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501F-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501R-Z-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501R-Z-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501R-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501RA-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501RA-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2501RA-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2802EA-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2802RA-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW2802RA-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW3200F": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDBW3231E-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200T-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200T-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200T-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200T-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TLM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TLMQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TMQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TMQ(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TMQ-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TMQ-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TMQ-Z(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1200TQ-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231G-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231T-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231T-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231TLM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231TLM": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231TLMQ(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231TMQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231TMQ-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231TMQ-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1231TQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1239T(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1239T-Z-A-LED-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1239T-Z-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1239TLQ(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1239TLQ-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1249SM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1249SM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1249XM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1249XM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500T-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500T-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500T-Z-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TLM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TLM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TLMQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TLQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TMQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TMQ-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1500TQ-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1509T-A-LED-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1509T(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1509T-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1509T-Z-A-LED-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1509T-Z-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1509TLQ(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1549SM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1549SM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1549X-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1549X-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1549XM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1549XM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1800M": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1800TLM(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1801CLQ-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1801T-Z-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1801TQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1801TQ-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1809T-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW1809TLM-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241T-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241T-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241T-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TLM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TLM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TLMQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TMQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TMQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TMQ-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TMQ-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2241TMQ-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2249T-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2249TLM-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501T-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501T-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501T-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TLM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TLM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TLMQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TLMQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TMQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TMQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TMQ-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TMQ-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TMQ-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TQ-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2501TQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2509T-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2509TLM-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2802T-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2802T-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2802T-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2802TLM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2802TMQ-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2802TMQ-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW2802TMQ-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HDW3200G": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200C(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200CL-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200CM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200CM(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200CM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200D": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200R-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200R-Z(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200R-Z-IRE6-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200RL(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200RL-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200RL-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200RM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200RM-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TH-I4-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TH-I8-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TH-I8-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TL": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TLM-I6(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TLM-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1200TM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1231R-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1231R-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239C(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239C-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239T(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239TLM(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239TM-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239TM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239TU-Z-A-LED-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1239TU-Z-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1249SM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1249SM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1249XM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1249XM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500CM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500R-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500R-Z-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500R-Z-IRE6-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500RL(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500RL-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500RL-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500RM(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500RM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500RM-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500TH-I8-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500TH-I8-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500TH-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500TLM(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500TLM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500TLM-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1500TM-I8-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509C(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509T-A-LED-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509T(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509TLM(-A)-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509TM-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509TU-Z-A-LED-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1509TU-Z-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1549SM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1549SM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1549X-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1549X-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1549XM-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1549XM-IL-A-PRO": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1800T(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1800TH-I4": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1800TH-I8": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1800TL(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801R-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801R-Z-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801RL(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801RL-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801RL-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801RM(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801RM-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801RM-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801TH-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801TH-IL-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801TLM(-A)": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801TLM-IL-T": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1801TM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1809T-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW1809TLM-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2241CM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2241CM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2241TU-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2241TU-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2241TU-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2241TU-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2241TU-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2249T-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2249TU-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501CM-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501CM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501E-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501TU-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501TU-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501TU-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501TU-Z-A-POC": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2501TU-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2509T-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2509TU-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2802CM-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2802E-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2802TU-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2802TU-Z-A-DP": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW2802TU-Z-A": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW3231E-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-HFW3231E-Z12": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1200B-L": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1200B-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1200D-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1200EQ-L": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1200EQ-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1239H-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1239TH-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1500B-L": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1500B-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1500D-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1500EQ-L": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1500EQ-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1509TH-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1509TQ-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1800B-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1800EQ-L": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1800EQ-LS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1809H-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1809TH-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME1809TQ-A-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-ME2802B": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-PT1239A-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-PT1509A-A-LED": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-T2A21-U": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-T2A51-U": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-T3A21-VF": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-T3A21-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-T3A51-Z": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-E541F-E2-AS": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4K-B180": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B52IR-Z12E-S2": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-HDW2241T-ZS": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4K-T180": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SD6CE445GB-HNR": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T549M-ALED-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B54IR-Z4E-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T24IR-AS": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-E35IR-AS-S2": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4K-X-S2": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T28IR-AS-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B58IR-Z4E-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B58IR-ZE-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T58IR-ZE-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HAC-COLOR5M-TL": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B24IR-ZAS-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B28IR-ZAS-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B54IR-ZE-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B54PRO-Z4E": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B54PRO-ZE": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B58PRO-Z4E": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B8342-A180": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4M-T": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4M-TL": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4M-TZ": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4M-XL": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR8M-TL": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PDBW82041-B360-S2": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-F56IR-AS": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-PDW3849-A180-AS-PV": {
    "manufacturer": "Dahua",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T28IR-ZS-S2": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T54IR-AS-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T54IR-ZE-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T54PRO-AS": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T54PRO-ZE": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T58IR-SE-S3": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T58PRO-ZE": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ITC431-RW1F-IRL8": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-COLOR4K-T": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LPR431-Z4R": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ425DB-AT-R": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ4K-25X-PV": {
    "manufacturer": "Empire Tech",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "ANE-L7012L": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCO-7010RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCO-7020RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCO-7030RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCO-7070RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCV-7010RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCV-7020RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCV-7030RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HCV-7070RA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LNO-6070R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LNV-6020R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LNV-6070R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PND-9080R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNF-9010R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-12082RVD": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-7002VD": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-8082VT": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-9002VQ": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-9020V": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-9022V": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-9084QZ1": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-9084RQZ1": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-9085RQZ": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-C16083RVQ": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNM-C7083RVD": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNO-A9081R": {
    "manufacturer": "Wisenet",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNO-A9081RLP": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNV-9080R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PNV-A6081R-E-SOLIDEDGE": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "QND-6021": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "QND-8011": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "QND-8021": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "QNO-7020R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "QNV-6023R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "QNV-6024RM": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "QNV-8030R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SBO-147B": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SCV-6023R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SCV-6083R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SCV-6085R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SLA-T2480WA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SLA-T2480WDA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-3050T": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-6010M": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-7180RLP": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-C3012TRA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-C3020TRA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-C3022TRA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-C3030TRA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-C3032TRA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-L3030T": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-L4030T": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-L4030TR": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-L4040T": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-L4040TR": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNO-L4050T": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNU-4041T": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNU-4051T": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNV-C7013RC": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TNV-C8011RW": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XND-6081RF": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XND-6081VZ": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XND-6085V": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XND-8081REV": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XND-8081RV": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XND-8081VZ": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XND-L6080V": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNF-9013RV": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNO-6085R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNO-6123R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNP-6040HW": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNP-6371RH": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-6022R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-6081Z": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-6085": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-6120": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-8080RS": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-8080RSA": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-8081RE": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-8081Z": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-8083RZ": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-A8084R": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "XNV-L6080": {
    "manufacturer": "Hanwha",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CC12D9T-IT5E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CC52D9T-AVPIT3ZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CC52D9T-IT3E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2025FHWD-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2083G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2085G1-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2123G0-IU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2125G0-IMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2143G0-IU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2183G0-IU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2185G0-IMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2323G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2325FHWD-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2345FWD-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2365G1-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "Indoor": {
    "manufacturer": "Blink",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2625FHWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2665G0-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2685G0-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2725FHWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2725FWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2745FWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2765G0-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2785G0-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2935FWD-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2955FWD-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H25FWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H45FWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3125G0-IMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6D54FWD": {
    "manufacturer": "Annke",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-VFIR3E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6266T-25H2L": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6266T-50H2L": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N2404I-DE3": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N4215I-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N4225I-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4215ITG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4215T-D": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4215TG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4215TI-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4215TI-D": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4225ITG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4225T-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4225T-D": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4225TG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4225TI-D": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE4425ITG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5225ITG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5225T-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5225TG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5225TI-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5232ITG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5232T-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5232TG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5232TI-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE5425ITG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE7225TI-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE7232ITG": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2AE7232TI-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CC12D9T-AIT3ZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CC12D9T-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1021G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1021G2-IU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1023G0-IUF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1041G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1043G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1053G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1063G2-LIUF-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1067G3-LIU-F---SL---SRB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1083G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1083G0-IUF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1123G0-IUF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1167G3-LIU-F---SL---SRB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1167G3-LIUF----2-8MM-LATAM": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1183G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1183G0-IUF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1321-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1323G0-IUF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1323G0E-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1343G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1353G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1363G2-LIUF-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1367G3-LIU-F---SL---SRB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1383G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1383G0-IUF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1623G2-LIU-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1627G2H-LIU-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1643G2-LIU-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1643G2-LIZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1647G2H-LIU-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1663G2-LIZ-S-U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1663G2-LIZ-S-U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1A23G0-IZU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1A43G0-IZU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1B67G3-LIU-F---SL---SRB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1B67G3-LIU-F--LS-L--RB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1H23G0-IZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1H43G0-IZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1H53G0-IZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1T23G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1T43G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1T47G3-LIU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1T63G2-LIUF-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1T67G3-LIU-F---SL---SRB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD1T67G3-LIU-F--LS-L--RB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2021G1-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2041G1-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2051G1-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2065G1-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2126G2-IMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2163G0-IU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2321G0-I-NF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2325FWD-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2343G0-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2345G0P-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2347G3-LI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2366G2-ISU-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2367G2-L": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2383G2P-LISU-S-L--RB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2423G2-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2443G2-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2463G2-I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD26123G2-LIZS2UY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD26126G3-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD26166G3-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2623G2-LIZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2623G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2626G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2626G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2643G2-LIZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2643G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2646G1-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2646G2H-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2646G2HT-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2646G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2646G2T-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2647G2-LZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2647G2HT-LIZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2647G3-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2647G3T-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2663G2-LIZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2663G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2666G2H-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2666G2HT-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2667G2HT-LIZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2667G2T-LZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2667G3-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2667G3T-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2683G2-LIZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2683G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2686G2H-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2686G2HT-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2686G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2686G2T-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2687G2HT-LIZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2687G2T-LZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2687G3-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD27123G2-LIZS2UY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD27126G3-IPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD27166G3-IPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2723G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2726G1-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2726G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2743G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2746G2H-IPTRZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2746G2HT-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2746G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2746G3-IPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2747G2H-LIPTRZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2747G2H-LIPTRZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2747G3-LIPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2763G2-LIZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2763G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2766G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2766G2H-IPTRZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2766G2HT-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2766G3-IPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2767G2H-LIPTRZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2767G2H-LIPTRZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2767G2HT-LIZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2767G2T-LZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2767G3-LIPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2767G3T-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2783G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2786G2H-IPTRZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2786G2HT-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2786G3-IPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2787G2H-LIPTRZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2787G2H-LIPTRZS2U-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2787G2HT-LIZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2787G3-LIPTRZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H123G2-LIZS2UY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H126G3-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H166G3-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H23G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H26G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H43G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H55FWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H63G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H63G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H66G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H66G2H-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H66G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H67G3-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H83G2-LIZS2U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H85FWD-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H86G2H-IZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2H87G3-LIZSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2T66G2H-2I-4I": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2T83G2P-LISU-S-L--RB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD2T87G3-LIY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3023G2-LIU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3027G2-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3043G2-LIU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3046G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3047G2-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3063G2-IU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3063G2-LIU-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3063G2-LIU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3066G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3066G3-IU-SL-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3066G3-IU-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3083G2-LIU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3086G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3087G2-LSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3121G2E-LIU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3123G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3143G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3146G2-IMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3146G3-SU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3163G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3166G3-ISU-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3183G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3186G2-IMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3321G2-LIUF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3323G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3343G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3363G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3363G2-LIU-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3366G3-ISU-SL-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3366G3-ISU-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3383G2-LISU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3386G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3523G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3523G2-LIS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3543G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3543G2-LIS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3546G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3563G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3563G2-LIS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3566G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3566G3-IS-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3583G2-LIS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3586G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3621G2-LIZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3623G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3643G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3646G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3647G2-LZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3647G2T-LZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3663G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3663G2-LIZSU-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3663G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3666G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3666G3-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3666G3T-IZSU-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3683G2-IZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3683G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3686G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3721G2-LIZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3723G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3743G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3746G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3747G2T-LZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3763G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3763G2-LIZSU-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3763G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3766G2-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3766G3T-IZSU-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3783G2-IZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3783G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3786G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3787G2T-LZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3A26G2T-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3A46G2T-IZHS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3D46G2T-IZMSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3H23G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3H43G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3H63G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3H83G2-LIZSU": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3T63G2-LISU-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3T66G2-4IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3T66G3-2ISU-4ISU-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3T66G3-ISU-SL-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3T81G2P-LIUF-SL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD3T86G2-4IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD4B25G0-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6951G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6982G0-U": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP65",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6B25G0-PLWC03": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6B35G0-PLW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6D42G2-IS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6D44G1-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6D44G1H-IZS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CD6D55G2-IZHS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-FS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-LPFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-PF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF0T-PFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-LPFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-LSE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-PF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-PFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF8T-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF8T-FSLN": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF8T-PF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF8T-PFSLN": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DFT-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DFT-F28": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DFT-PF28": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10GF0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10GF0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10GF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10GF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10HFT-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10HFT-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10HFT-F28": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-FS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-LPFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF0T-PFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF3T-L": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF3T-LE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF3T-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF3T-LSYE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10KF3T": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10UF3T-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10UF3T-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10UF3T-LSYE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF0T-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF0T-FS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF3T-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF3T-FS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF3T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF3T-LSE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF3T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF8T-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DF8T-FSLN": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DFT-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12DFT-F28": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12GF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12GF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12HFT-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12HFT-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12HFT-F28": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF0T-FS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF3T-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF3T-L": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF3T-LE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF3T-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF3T-LSYE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12KF3TP-DLS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12UF3T-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12UF3T-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE12UF3T-LSYE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE13DF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C0T-IR": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C0T-IRP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C0T-IT1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C0T-IT1F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C0T-IT3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C0T-IT5": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C2T-IR": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16C2T-IT5": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-EXIF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-EXIP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-EXLF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-EXLPF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-I2FB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-I2PFB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IPF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IR": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IRE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IRF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IRP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IRPE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IT1E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IT3E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-IT5E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-LPXTS-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-LXTS-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-VFIR3E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D0T-VFIR3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D3T-I3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D3T-IT3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D3T-ITF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16D3T-ITPF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16G0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16G0T-LPFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16G0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16G0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16G0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16G0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-AIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-IT1F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-IT3ZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-IT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-IT5E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-ITE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-ITF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-ITFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-ITPF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16H0T-ITPFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16K0T-EXLF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16K0T-EXLPF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16K0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16K0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16K0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16K0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16K0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U0T-LF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U0T-LPF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U1T-IT1F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE16U1T-ITF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-EXLF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-IT1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-IT1F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-IT3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-IT5": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-IT5F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17D0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17G0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17G0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17G0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17H0T-IT1F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17H0T-IT3FS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17K0T-EXLF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17K0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17K0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17K0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17U0T-LF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17U0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17U0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE17U8T-IT": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE18D0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE18K0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE18U8T-IT3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19D0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19D0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19D3T-AIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19D3T-IT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19DF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19DF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19DF3T-LSZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19DF3T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19DF8T-AZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19G0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19G0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19GF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19GF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19H0T-AIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19K0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19K0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19K0T-LXTSZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19KF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19KF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19U0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19U0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19U1T-AIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19U1T-IT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE19U8T-AIT3Z": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE1ADF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE50DF3T-VPLFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE50DF3T-VPLSE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE50DF3T-VPLSZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE50K0T-VPLTSZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE52K0T-LPS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C0T-IR": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C0T-IRF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C0T-IRM": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C0T-IRMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C0T-IT1F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C0T-IT3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C2T-IRM": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56C2T-VFIR3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IR": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IRF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IRM": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IT1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IT1E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IT3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IT3E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-IT3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-VFIR3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-VPIR3E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56D0T-VPIR3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56H0T-AVPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56H0T-IT3E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56H0T-IT3ZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56H0T-IT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56H0T-ITME": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56H0T-VPIT3ZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE56H0T-VPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE57D3T-VPITF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE57H0T-VPITF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE57U1T-VPITF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE59DF8T-AVPZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE59U1T-AVPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE59U1T-VPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE59U8T-AVPIT3Z": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AD0T-VPIT3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AD3T-AVPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AD3T-VPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AH0T-AVPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AH0T-VPIT3ZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AH0T-VPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AU1T-AVPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE5AU1T-VPIT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE60DF0T-PTLXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE60KF0T-PTLXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70D0T-ITMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF0T-LMFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF0T-MF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF0T-MFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF3T-LMFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF3T-MF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF3T-MFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF8T-MF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70DF8T-MFSLN": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70KF0T-LMFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE70KF0T-MFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF3T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF3T-LSE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF3T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DF8T-FSLN": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DFT-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72DFT-F28": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72GF0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72GF0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72GF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72GF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72HFT-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72HFT-F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72HFT-F28": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF3T-L": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF3T-LE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF3T-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF3T-LSYE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF3T": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF3TP-DLS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72UF3T-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72UF3T-LSYE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE73DF0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76D0T-EXIMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76D0T-EXLMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76D0T-ITMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76D3T-ITMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76G0T-LMFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76K0T-EXLMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76K0T-LMFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE76U0T-LMF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78D0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78D0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78D0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78D0T-LXTS-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78D0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78D3T-IT3F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78G0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78G0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78G0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78G0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78G0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78K0T-LFS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78K0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78K0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78K0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78K0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78U0T-LF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78U0T-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78U0T-LPXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78U0T-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78U0T-LXTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE78U1T-IT1F": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE79D3T-IT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE79DF8T-AZE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE79H0T-IT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE79K0T-LXTSZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE79U1T-IT3ZF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE79U8T-IT3Z": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CFW06-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV1021G0-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV1123G2-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV1143G2-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2021G2-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2026G0-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2027G0-LDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2041G2-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2046G0-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2121G2-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2126G0-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2141G2-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CV2146G0-IDW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2A204IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2A404IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2A604IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2C200MWG-4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2C200MWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2C200SCG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2C400MWG-4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2C400MWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2C400SCG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE2C600MWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE3204W-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4215IW-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4215IWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4215IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4215W-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4225IW-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4225IWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4225IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4225W-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4225W-DE3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4415IW-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4415IWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4415IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4425IWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4425IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4425W-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4825IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4825WG-E3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4A225IWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4A225IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE4A425IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5225IW-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5225W-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5225W-AE3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5232IW-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5232W-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5330W-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5330W-AE3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5425IWG-4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5425IWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5425IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5425W-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5432IWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5432IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE5432WG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7225IW-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7232IW-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7425IW-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7530IW-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A220MCG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A225IWG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A225IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A232IWG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A232IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A412MCG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A425IWG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A425IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A425MWG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A432IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A432MWG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A632IWG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A632IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A812MCG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A825IWG-EB": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DE7A825IWG1-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF5225X-AE3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF5225X-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF5232X-AE3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF5232X-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF6A236X-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF6A425X-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF6A436X-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF6A836X-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF7225IX-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF7232IX-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF7232IX-AELW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF8A436IX-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF8A836IX-AEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF8C425MHS-DEL": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF8C425MHS-DELW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF8C842IXS-AELW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF9C435IH-DLW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF9C453LXG-LW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DF9C848LXG-LW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DV6C425MXG-ELW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DV6C425MXG-ELWY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY3220IW-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY3220IW-DE4": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY3320IW-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY3320IW-DE4": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY5223IW-AE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY5425IXG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY5432IXG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY5432IXG-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY5440IXG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY5A432MWG-ELW": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY7236IW-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY7236W-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY9225IH-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY9236IX-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY9236X-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY9250IAX-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2DY9250IX-A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2PT5326IZ": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2SE4C225MWG-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2SE4C415MWG-E-14": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2SE7C432MWG-EB-26": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TA03-15SVI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TA06-25SVI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TA21-2AVF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TA21-3AVF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD1217-2-PA": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD1217-3-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD1217-3-PA": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD1217-6-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD1217-6-PA": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2136T-10": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2136T-25": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-10-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-10-PY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-15-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-15-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-15-PY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-25-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-25-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-25-PY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-35-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-35-PY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-4-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-7-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137-7-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137T-4-QY0": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2137T-7-QY0": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2138-13-QY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2138-35-QY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2166T-15": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2166T-25": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2336-100": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2336-50": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2366-100": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2366-75": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2367-100-PY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2367-50-PY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2367-75-PY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2466-25Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2466-50Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2608-1-QA-FP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2608-1-QA": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2608-2-QA-FP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2608-2-QA": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-10-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-10-PA": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-10-PAI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-10-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-3-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-3-PAI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-3-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-3-V1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-6-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-6-PA": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-6-PAI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2617-6-PI": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2628-10-QA-GLT": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2628-3-QA-GLT": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2628-7-QA-GLT": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2637-35-QY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2637-7-QY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2637T-10-QY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2637T-15-QY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD2836-25-V1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD4136T-25": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD5537T-15-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6236-75C2L-V2": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6237-50H4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6237-75C4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6237T-25H4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6237T-50H4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6266-100C2L-V2": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6266-50H2L-V2": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6267-100C4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6267-100C4L-WY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6267-75C4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6267-75C4L-WY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6267T-25H4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6267T-50H4L-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6537T-25H4LX-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6537T-50H4LX-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6567T-25H4LX-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD6567T-50H4LX-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD95C8-150ZE4FL-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD95C8-190ZK2FL-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TD95C8-300ZK2FL-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3636-10A-V1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3636-10P-V1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3636-15P-V1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3636-25P-V1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3636-35P-V1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-10A-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-10P-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-15A-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-15P-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-25A-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-25P-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-35A-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TX3742-35P-Q": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TXS2628-10P-QA-GLT-CH30S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TXS2628-10P-QA-GLT-CH36S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TXS2628-3P-QA-GLT-CH30S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TXS2628-3P-QA-GLT-CH36S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TXS2628-7P-QA-GLT-CH30S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2TXS2628-7P-QA-GLT-CH36S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XS3Q47G1-LDH-4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP65"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XS6A87G1-L-C32S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XS6F45G1-IC1--C2--4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XS6F45G1-IC1-S-4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XS6F85G1-I-L-C1-4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XS6K01-C36S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XS6K02-C36S80": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XT6445G2-L-C08": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XT6645G0-LIZS-C15": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XT6645G0-LIZS-C25": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XT6685G0-LIZS-C25": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2XV6445G0-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP68"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1218-2-G0-T1A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1218-3-G0-T1A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1218-7-G0-T1A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1228-2-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1228-3-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1228-7-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1228T-2-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD1228T-3-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2168-5-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2168-5-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2618-10-G0-T1A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2618-3-G0-T1A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2618-7-G0-T1A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2628-3-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2628-7-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2628T-3-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2628T-7-G1-T3A": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-10-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-15-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-25-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-35-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-4-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-4-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-8-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638-8-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638T-10-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638T-10-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638T-4-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638T-4-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638T-8-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2638T-8-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-10-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-10-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-15-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-15-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-25-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-25-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-35-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668-35-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668T-10-G0-T1Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD2668T-10-G1-T3Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5528T-10-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5528T-15-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5537T-15-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5537T-25-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5537T-7-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5567T-15-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5567T-25-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD5567T-7-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD6338-50C4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD6338-75C4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD6368-100C4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD6368-130ZC4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD6368-50C4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD6368-75C4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD63C8-100C4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD63C8-75C4L-G0-T2Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD7168-55-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD7168-75-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD71C8-55-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD71C8-75-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD95C8-150ZE4FL-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD95C8-190ZK4FL-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TD95C8-300ZK4FL-W": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX2840-10-G0-T1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX2840-10-G1-T3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX3840-10-G0-T1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX3840-10-G1-T3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX3840-15-G0-T1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX3840-15-G1-T3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX3840-25-G0-T1": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HM-TX3840-25-G1-T3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD5A46G2-XZ-H-S-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD70166G2-AP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7086G2-AP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD70C6G2-AP": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7146G2-LM-IZ-H-S-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7186G2-LM-IZ-H-S-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD72265G0-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD72325G0-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7547G2-P-XZHS-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7547G2-XZHS-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7547G2-ZHS-RC": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7587G2-P-XZHS-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7587G2-XZHS-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7587G2-ZHS-RC": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7A166G2-IZHSY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7A46G2-IZHS-Y--4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7A46G2-LM-IZHS-Y": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7A46G2-P-IZHS-Y--4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7A86G2-IZHS-Y--4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD7A86G2-P-IZHS-Y--4G": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD8A46G0-IZ-UH": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IDS-2CD8A47G0-SC-ZY": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B120HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B120HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B129H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B129HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B129HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B129HAA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B140H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B140HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B140HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B149H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B149HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B149HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B160HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B169HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B169HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B180H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B180HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B420H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B420HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B420HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B429H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B429HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B429HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B429HAA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B440H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B440HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B440HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B449H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B449HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B449HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B459H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B460HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B469HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B469HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B480H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B480HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B520HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B529HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B529HAA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B540HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B549HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B620HA-LZU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B620HA-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B640H-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B640HA-LZU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B640HA-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B650H-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B660HA-LZU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D120HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D120HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D129H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D129HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D129HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D140H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D140HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D140HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D149H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D149HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D149HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D160HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D169HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D169HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D180H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D180HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D620HA-LZU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D620HA-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D640H-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D640HA-LZU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D640HA-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D650H-Z": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D660HA-LZU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK08"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T220HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T221H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T229H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T229HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T229HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T229HAA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T240H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T240HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T249H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T249HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T249HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T250H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T260HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T269HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T269HA": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T280H": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T280HA-LU": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T621H-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T640HA-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T641H-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T651H-Z": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N2204I-DE3": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N2C200C-DE": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N2C200M-DE": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N2C400M-DE": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N2C600M-DE": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N4415-DE3": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N4425I-DE": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N5225I-A": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N5225I-DE": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-N5425I-DE": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE10DF3T-FS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DS-2CE72KF3T-E": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T223-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-T4215I-D": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-T4225I-D": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "PTZ-T4425I-D": {
    "manufacturer": "HiLook",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B110-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B110-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B120-C": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B120-PIC": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B123-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-LMC": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-LPC": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-LPS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B127-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B129-LPS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B129-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B129-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B129-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B129-PS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B157-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B157-LPS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B157-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B157-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B159-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B159-LPS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B159-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B210": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B220-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B220": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B223-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B223": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B227-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B227-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B229-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B229-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B229-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B240-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B240": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B257-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B257-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B259-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B259-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B310-VF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B323-Z": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-B340-VF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-D310-VF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-D323-Z": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T110-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T110": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T120": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T123-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T127-LMC": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T127-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T127-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T129-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T157-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T159-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T159-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T220-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T220-P": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T227-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T227-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T229-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T229-LPTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T229-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T229-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T229-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T240-M": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T257-LMS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T257-LTS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T259-LS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T259-MS": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T310-VF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T320-VF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T323-Z": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "THC-T340-VF": {
    "manufacturer": "Hikvision",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D2214R": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D2234WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D2511WER": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D2531WER": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D2531WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4211CRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4236HRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4236RX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4236WRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4237RX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4238HRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4246WX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4248HRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4532WERA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4536HRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4536RX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4538RA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4538WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4548WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D4831HRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-D6631WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S4561WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6261X": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6281FX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6281HX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6286HRXL": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6481HRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6682WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6683WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6882WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-S6883WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T2214WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T2234WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T2511WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T2531WR": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4236HRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4236WRX-A": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4236WRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4238HRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4248HRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4536HRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4538WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T4831HRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-T6631WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-Y6516WRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-Y6516X": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-Y6C16WRX": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DC-Y8D11WRA": {
    "manufacturer": "IDIS",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T",
        "M",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SBV111M": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SBV131M": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SF342": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SF346": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV310": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV310A": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV311": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV311A": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV531": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV611L": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV631L": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV631LT": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-SFV781L": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-V2530L1": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "WV-V2530LK": {
    "manufacturer": "i-PRO",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LVDBH5XRL4R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LVDBH5XRL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LMDERL400": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCHFG200W": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCFG400W": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LMDHRL4R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LMDHRL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LMBM36FW400W": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LMCM36FW400W": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCKL5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCKL5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBKL5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCKL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMLCKL5AD": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LVDBHKL8R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEKL5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEKL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLE5XKL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLCKL5AD": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSEKL5AD": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BPSCFC2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BPSCFC4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFC2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFC4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LIRDCAKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DMMAKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DMMAKL5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLEKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LVDBHKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL2RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFC8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCKL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBKL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCKL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEKL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSEKL8AD": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLCKL8AD": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMLCKL8AD": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL5RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL8R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBFCV2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCFCV2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLEFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEFCV2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBFCV5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCFCV5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEFCV5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLEFCV5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFCV5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCFCV5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBFCV5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBFCV8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCFCV8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEFCV8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLEFCV8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFCV8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCFCV8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBFCV8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMCKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TH2AFC2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TH2AFC4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TH2AFC8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LIRDCAKL5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSFRL4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDRL4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSFRL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDRL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCRL4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCRL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSERL4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSERL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLCRL4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLCRL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLERL4RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLERL8RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBRL4RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBRL8RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDRL4RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDRL8RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMERL4RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMERL8RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL2R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDFCV5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDFCV8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL8RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL2RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL5R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL8RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLFKS8DP": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DMSAKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLFKS16DP": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DMMAKL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL12RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCKL12RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBKL12RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TP2CFC2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TP2CFC4RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMCKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL5R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMLDKL8AD-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL8R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSFNP4AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSFNP8AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLENP4AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLENP8AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBNP4AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBNP8AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMENP4AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMENP8AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDNP4AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDNP8AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMLDNP4AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMLDNP8AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSFNP12AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLENP12AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBNP12AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMENP12AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDNP12AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMLDNP12AC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DMSAKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFCV2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFCV5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSDFCV8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCFCV2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCFCV5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMSCFCV8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDFCV2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL2R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDFCV5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL5R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDFCV8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL8R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLEKL2RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LVDBHKL2R-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLEKL5RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMDKL5RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMLEKL8RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "BMMBKL8RC-X5": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSEKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCFCV2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSCKL2RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TH2AFCV2R": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CMSBFCV5RC": {
    "manufacturer": "Longse",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "1080P-WI-FI-FLOODLIGHT-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP65"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "E842CA-4K-IP-WIRED-BULLET-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "E842CD-4K-IP-WIRED-DOME-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "E851-4K-IP-WIRED-DOME-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "E863SB-4K-BULLET-POE-IP-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "E863SD-4K-IP-DOME-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "E872-DUAL-LENS-OUTDOOR-IP-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "E896AB": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F861ASD-4K-SPOTLIGHT-BATTERY-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP65"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LNB45AB-A4-IP-WIRED-BULLET-CAMERAS": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LND45DV-A4-IP-WIRED-DOME-CAMERAS": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LNE45AB-A4-IP-WIRED-TURRET-CAMERAS": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "LNZ45P25-2K-4MP-WIRED-PTZ-IP-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "F461AQD-E": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NOC4-LITE-4K-NOCTURNAL-BULLET-IP-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NOC4-LITE-4K-NOCTURNAL-TURRET-IP-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TF461AQD-E-2PK-2K-PTZ-WIFI-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "W891UAD-E-4K-DUAL-LENS-WI-FI-CAMERA": {
    "manufacturer": "Lorex",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "12X-AI-AF-MOTORIZED-PRO-BULLET-CAMERA": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "G",
        "M",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "23X30X-AI-SPEED-DOME": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "G",
        "M",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "23X36X-AI-LPR-SPEED-DOME": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "M",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "36X42X-AI-SPEED-DOME": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10",
      "onvifProfiles": [
        "G",
        "M",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "5G-MOTORIZED-PRO-BULLET-PLUS": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "G",
        "M",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "5G-PRO-BULLET-PLUS": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "M",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-12X-AF-PRO-BULLET": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "G",
        "M",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NDAA-AI-FISHEYE-CAMERA": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "Q",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NDAA-AI-LPR-23X36X-SPEED-DOME-CAMERA": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "Q",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NDAA-AI-LPR-MOTORIZED-BULLET-CAMERA": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "Q",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NDAA-AI-LPR-MOTORIZED-PRO-DOME-CAMERA": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "Q",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NDAA-AI-LPR-PTZ-BULLET-PLUS-CAMERA": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "Q",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "NDAA-RADAR-AI-LPR-PRO-BULLET-PLUS-CAMERA": {
    "manufacturer": "Milesight",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "G",
        "Q",
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR5350KABS-S-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR5350MBBS-S-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7120BZAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7150HKAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7150KFAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7150KFAC-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7180HKAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7180KFAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7180KFAC-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7241KFAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7241MFAS-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7281KFAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR7281MFAS-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041BYAN-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041CBAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041CBAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041CQAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041DQAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041DQAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041HCAW-B-SECURITY": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8041HDAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8045AKAN-T-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8045DQAN-T-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8045DQAN-T-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8046DKAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8046DKAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8046HKAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8046HKAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8047AKAN-ST1-PZ-ANPR-CAMERAS": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8056DKAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8056DKAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8056HKAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8056HKAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8080CQAA-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8080DKAS-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8080DQAA-Z-OUTDOOR": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8080HCAA-B-SURVEILLANCE": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8080HKAN-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084AKAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084BYAN-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084BZAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084CAAS-VZ-SMART-DUAL-LIGHT": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084CBAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084CBAW-B-FULL": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084DKAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084DQAF-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084DQAN-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084DQAS-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8084DQAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8152KKAC-B-180-PANORAMIC": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8540DQAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8540DQAW-PZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPR8540KFAE-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7120EEAR-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7120HDAR-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7150HCAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7150HNBC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7180HCAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7180HNBC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7241KFAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV7281MFAC-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8060ECAR-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084CQAF-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084CQAR-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084CQAS-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084CQAS-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084CQAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084EDAR-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084EEAR-VZ-VANDAL-PROOF": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084EFAR-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084EGAR-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084EWAR-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084HCAR-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084HCAS-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084HCAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084HDAF-Z": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084HDAR-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084HDAS-VZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8084HDAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8146HCBR-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8146HCBS-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8540CQAE-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8540DQAE-PZ": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "SN-IPV8540HDAW-B": {
    "manufacturer": "Sunell",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "DoorBell": {
    "manufacturer": "Ajax",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP65"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "CoreCam": {
    "manufacturer": "Swann",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP65"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B122-APF28K": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B124-APF28K": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B132-AF28-DL-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B132-AF28-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B134-AF28-DL-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B134-AF28-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B232-AF40-DL-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B232-AF40-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B234-AF40-DL-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B234-AF40-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B242-ADF28K-WP": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B244-ADF28K-WP": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-B314-ADZK": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D122-PF28": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D122-PF28K": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D124-PF28K": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D312-ADZK": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-D314-ADZK": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-P222-AF40C": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-P224-AF40C": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-P413-X20K": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T122-APF28K": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T124-APF28K": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T132-AF28-DL-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T132-AF28-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T134-AF28-DL-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T134-AF28-ECO": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T242-ADF28K-WP": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T244-ADF28K-WP": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T312-ADZK": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC-T314-ADZK": {
    "manufacturer": "Uniarch",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HC151-GHN-2C32S-OS": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HC191-GHN-2C32S-OS": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "HC191-GI-OS": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP65"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2122LB-ADF28KM-K": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2122LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2122LB-AF28K-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2122LB-AF28K-DL2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2122LB-AF28K-WL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2122LB-AF28WK-WF": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2124LB-ADF28KM-K": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2124LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2124LB-AF28K-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2124LB-AF28K-DL2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2124LB-ASF28K-A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2124LE-ADF28KM-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2124SB-ADF28KMC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2125LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2125LE-ADF28KM-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2128LB-ADF28K-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2128LB-ADF28K-G": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2128LE-ADF28KM-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2128LE-ADF28KMC-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2128SB-ADF28KMC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2222SB-AHDF60KM-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2224SE-DF40K-WL-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2225SB-ADF60KM-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2225SE-DF40K-WL-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2228SB-ADF28KM-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2228SB-ADF40KM-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2312LE-ADF28K-WP-L": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2314LE-ADF28K-WP-L": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2314LE-ADF28KM-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2318LE-ADF28KM-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2322LB-ADEZK-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2322LB-ADZK-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2322SB-HDZK-PI-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2324LB-ADEZK-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2325LB-ADZK-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC245LP-ADF40KC-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC264EA-AHDZK-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC268EA-AHDZK-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2A12LP-ADF40KC-4G-E": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2A12LP-ADF40KC-4G-JP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2A14LP-ADF40KC-4G-E": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2B15SS-ADF28KMC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2B18SS-ADF28K-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2B22SA-AHDZK-PI-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2B24SA-AHDZK-PI-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2B24SA-AHDZK-PI-LS-I2A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2B28SA-ADZK-PI-I2A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC2B28SA-ADZK-PI-LS-I2A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC312LE-ADF28K-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC312SB-ADF28K-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC314LE-ADF28K-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC314SB-ADF28K-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC314SB-ADF28K-M12-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC314SB-ADF28KMC-DL-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC318SB-ADF28K-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC318SB-ADF28KMC-DL-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3222SS-ADF40K-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3224SS-ADF40K-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC322LB-ADF28K-K": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC322LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC322LB-AF28K-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC322LB-AF28WK-G": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC322LB-ASF28K-A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC322LB-SF28-A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC322LB-SF28K-A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3232SA-AHDZK-PI-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3232SB-AHDZK-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3232SB-AHDZK-PI-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3234EA-AHDZK-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3234SA-AHDZK-PI-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3234SA-AHDZK-PI-LS-I2A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3238EA-AHDZK-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3238SA-ADZK-PI-I2A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3238SA-ADZK-PI-LS-I2A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC324LB-ADF28K-K": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC324LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC324LB-AF28K-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC324LB-ASF28K-A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC324LB-SF28-A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC325LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC325LB-SF28-A": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC325LE-ADF28K-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC328LE-ADF28K-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3522LE-ADF28K-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3524LE-ADF28K-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3528LE-ADF28K-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3532LB-ADEZK-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3534LB-ADEZK-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3612LB-ADF28K-K": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3612LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3612LB-AF28K-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3612LB-AF28K-DL2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3612LB-AF28K-WL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3614LB-ADF28K-K": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3614LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3614LB-AF28K-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3614LB-AF28K-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3614LB-AF28K-DL2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3614LE-ADF28K-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3614SB-ADF28KMC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3615LB-AF28-A2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3615LE-ADF28K-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3616LE-ADF28K-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3618LB-ADF28K-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3618LE-ADF28K-H": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3618LE-ADF28KC-DL": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3618SB-ADF28KMC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3618SE-ADF28KM-WL-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3622LE-ADF28K-WP-L": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3624LE-ADF28K-WP-L": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3624LE-ADF28K-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3628LE-ADF28K-WP": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3634SE-ADF28K-WL-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3634SE-ADF28K-WP-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3634SS-ADF28K-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3634SS-ADF28KMC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3635SS-ADF28K-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3635SS-ADF28KMC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3638SE-ADF28K-WP-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC3638SS-ADF28K-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC542SE-HDK-I0": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC6312LR-AX4W-VG": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC6314LWH-AX5C-VG2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC6324LWH-AX5C-VG2": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC6415SR-X5UPW-VG": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC6652EL-X33-VF": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC7622ER-X44-VF": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC9312LFW-AF28-2X4": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "M"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "IPC98246EFW-X42-W-VH1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "ikRating": "IK10"
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TIC2621SR-F3-4F4AC-VD": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TIC2A32SA-F10-4F8AC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TIC2A32SA-F3-4F4AC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TIC2A32SA-F7-4F6AC-I1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP67",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  },
  "TIC7626EL-GAF75-4X56-VH1": {
    "manufacturer": "Uniview",
    "status": "compliance",
    "sources": [],
    "spec": {
      "ipRating": "IP66",
      "onvifProfiles": [
        "S",
        "G",
        "T"
      ]
    },
    "notes": [
      "IR range not checked — compliance-only audit (IP/IK/ONVIF certifications)"
    ]
  }
} as const;

export function getVisibleSpec(modelName: string | undefined | null): VisibleIndexEntry | undefined {
  if (!modelName) return undefined;
  return VISIBLE_SPECS_INDEX[modelName];
}

export function isVerifiedVisibleModel(modelName: string | undefined | null): boolean {
  return getVisibleSpec(modelName)?.status === 'verified';
}
